const AUCTIONS_DATA = [
  {
    auctionID: 6789,
    symbolID: "THE_BOX",
    symbolType: "Part of an album",
    title: "The Box",
    genre: ["Rap", "Hip-Hop"],
    description: `"The Box" by Roddy Ricch is a chart-topping hip-hop track that captivated audiences with its catchy melodies, hard-hitting beats, and Roddy Ricch's distinctive vocal delivery.
    Released in 2019 as part of his debut album "Please Excuse Me for Being Antisocial," the song quickly gained immense popularity and solidified Roddy Ricch as a rising
    star in the music industry. "The Box" showcases Ricch's versatile style, blending elements of trap, rap, and melodic flows. The song's infectious hook and memorable lyrics,
    coupled with its energetic production, create an irresistible sonic experience that resonates with listeners. With its unique sound and powerful delivery, "The Box" became a
    cultural phenomenon and further established Roddy Ricch as one of the most exciting artists in contemporary hip-hop.`,
    startDate: "05/12/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 100,
    minAuctionTarget: 300000,
    minOrder: 50,
    currentPrice: "$14.35",
    priceIncrease: "$0.02",
    averageYield: "10%",
    LTMYield: "8.5%",
    lastPrice: "$14.35",
    weeklyVolume: "45",
    change: "3.01%",
    dalyGain: "$0.02",
    totalGain: "$7.8",
    royalties: "$12.39",
    aveCost: "$7.8",
    orderType: "Auction",
    bidPerUnit: "6.70",
    bidUnits: "23",
    askPerUnit: "14",
    askUnits: "12.39",
    spotifyLink:
      "https://open.spotify.com/track/0nbXyq5TXYPCO7pr3N8S4I?si=48b5fa140a0f4d0f",
    imgSrc: ["auctions/the-box.jfif"],
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$113,000",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$130,000",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Part of an album",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "1",
      },
      {
        title: "Record lable",
        description: "Atlantic Records",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/fg3H-KFUXVA",
        thumbnail: "tracks/the-box-video.png",
      },
    ],
    tracks: [
      {
        id: "27599255",
        isrc: "USAT21906978",
        title: "The Box",
        artist: "Roddy Ricch",
        album: "The Box",
        releaseDate: "12/05/2019",
        spotifyLink:
          "https://open.spotify.com/track/0nbXyq5TXYPCO7pr3N8S4I?si=48b5fa140a0f4d0f",
        imgSrc: "tracks/the-box.png",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 2000,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 5003604,
              },
              likes: {
                title: "Likes",
                value: 516146337,
              },
              views: {
                title: "Views",
                value: 4114763138,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 161095443,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 257597084,
              },
              trackStations: {
                title: "Track Stations",
                value: 609002,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 83,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 69898713,
              },
              streams: {
                title: "Streams",
                value: 1634347508,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1182153699,
              },
              likes: {
                title: "Likes",
                value: 15105438,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3398236,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 9581043,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 563690,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 5731,
              },
              count: {
                title: "Listen Count",
                value: 631090,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 23878,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 748933,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://rapradar.com/2023/03/31/album-dj-drama-im-really-like-that/",
        title: "Album: DJ Drama ‘I’m Really Like That”",
        source: "Rap Radar",
        image_url:
          "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
        date: "2023-03-31T04:04:00.000Z",
      },
      {
        url: "https://www.billboard.com/lists/song-of-the-summer-2023-early-contenders/",
        title:
          "Way-Too-Early Song of the Summer 2023 Contenders: The Front-Runners, Outside Shots & Question Marks",
        source: "billboard",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
        date: "2023-03-30T19:55:01.000Z",
      },
      {
        url: "https://allhiphop.com/news/tyler-the-creator-explains-why-being-a-rapper-is-awesome/",
        title: "Tyler, The Creator Explains Why Being A Rapper Is “Awesome”",
        source: "AllHipHop",
        image_url:
          "https://video.primis.tech/uploads/video/users/logo/30526/logo_9860.png?cbuster=1616405498",
        date: "2023-03-30T12:33:30.000Z",
      },
      {
        url: "https://www.okayplayer.com/music/tyler-the-creator-sorry-not-sorry.html",
        title:
          "Watch Tyler, the Creator Channel All His Eras In the “Sorry Not Sorry” Music Video",
        source: "Okayplayer",
        image_url:
          "https://yt3.ggpht.com/ytc/AMLnZu9tabEaPKboW0n_5riHUHmVsHtycyBU6zvmlKnTpg=s88-c-k-c0x00ffffff-no-rj",
        date: "2023-03-29T16:54:24.000Z",
      },
      {
        url: "https://www.complex.com/music/best-new-music-this-week-march-6lack-bia-chloe/",
        title: "The Best New Music This Week: 6LACK, BIA, Chlöe, and More",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-24T19:02:52.000Z",
      },
      {
        url: "https://www.complex.com/music/internet-money-kodak-black-roddy-ricch-i-remember",
        title:
          'Internet Money Enlists Kodak Black and Roddy Ricch for New Single "I Remember"',
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-24T16:37:30.000Z",
      },
      {
        url: "https://www.clashmusic.com/news/internet-money-link-with-roddy-ricch-kodak-black-on-i-remember/",
        title:
          "Internet Money Link With Roddy Ricch, Kodak Black On ‘I Remember’",
        source: "Clash",
        image_url:
          "https://www.clashmusic.com/wp-content/themes/chop-child/images/clash-logo.png",
        date: "2023-03-24T11:30:50.000Z",
      },
      {
        url: "https://www.rollingstone.com/music/music-news/dababy-copyright-lawsuit-rockstar-1234645951/",
        title: "DaBaby Hit With Copyright Lawsuit Over ‘Rockstar’",
        source: "Rolling Stone",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Rolling_Stone_2019.svg/180px-Rolling_Stone_2019.svg.png",
        date: "2022-12-12T17:50:52.000Z",
      },
      {
        url: "https://2dopeboyz.com/2022/12/12/little-simz-no-thank-you-album-stream/",
        title: "Little Simz Drops Surprise Album, ‘NO THANK YOU’",
        source: "Two Dope Boyz",
        image_url:
          "https://2dopeboyz.com/wp-content/uploads/2016/10/new2dbz-logo-header-1.png",
        date: "2022-12-12T17:36:25.000Z",
      },
      {
        url: "https://allrapnews.com/news/a-boogie-wit-da-hoodie-me-vs-myself-stream/",
        title: "A Boogie Wit Da Hoodie Drops New Album ‘Me Vs. Myself’",
        source: "All Rap News",
        image_url:
          "https://allrapnews.com/wp-content/uploads/2021/08/111ARN-logo.png",
        date: "2022-12-09T13:05:14.000Z",
      },
      {
        url: "https://allhiphop.com/news/a-boogie-wit-da-hoodie-returns-with-me-vs-myself-album/",
        title: "A Boogie Wit Da Hoodie Returns With ‘Me Vs. Myself’ Album",
        source: "AllHipHop",
        image_url:
          "https://video.primis.tech/uploads/video/users/logo/30526/logo_9860.png?cbuster=1616405498",
        date: "2022-12-09T11:30:00.000Z",
      },
      {
        url: "https://www.complex.com/music/a-boogie-wit-da-hoodie-me-vs-myself-stream",
        title:
          "A Boogie Wit Da Hoodie Shares 'Me vs. Myself' Album f/ Roddy Ricch, Kodak Black, Lil Durk, and More",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2022-12-09T05:14:22.000Z",
      },
      {
        url: "https://rapradar.com/2022/12/09/album-a-boogie-wit-da-hoodie-me-vs-myself/",
        title: "Album: A Boogie Wit Da Hoodie ‘Me vs. Myself’",
        source: "Rap Radar",
        image_url:
          "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
        date: "2022-12-09T05:02:00.000Z",
      },
      {
        url: "https://variety.com/2022/music/news/atlantic-julie-greenwald-and-craig-kallman-clive-davis-pre-grammy-party-1235453746/",
        title:
          "Atlantic’s Julie Greenwald and Craig Kallman to Be Honored at Clive Davis Pre-Grammy Gala",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2022-12-08T13:59:00.000Z",
      },
    ],
    artist: {
      id: 839964,
      name: "Roddy Ricch",
      biography: `Rising from the streets of Compton but with a distinct Southern flair, rapper Roddy Ricch lays his introspective rhymes atop melodic trap, 
      resulting in a hybrid form that has captured the ears of both regions. The MC broke through in 2018 with the platinum single "Die Young" and topped the 
      Billboard 200 the next year with Please Excuse Me for Being AntiSocial. Sophomore album Live Life Fast arrived in December 2021. Both that record and the 
      2022 mixtape Feed tha Streets III broke into the upper reaches of the charts.`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 9386911,
              rank: 207,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 1600000000,
              rank: 212,
            },
            popularity: {
              title: "Popularity",
              value: 79,
              rank: 251,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 205872707,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "40.81%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "21.93x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7152250,
              rank: 1058,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5400000,
              rank: 578,
              monthly_diff: {
                value: 0,
                percentage: 0,
              },
            },
            likes: {
              title: "Likes",
              value: 18500000,
              rank: 2173,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 10732294558,
              rank: 144,
            },
            postCount: {
              title: "Post Count",
              value: 13720262,
              rank: 74,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 6700000,
              rank: 616,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2940431924,
              rank: 617,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1085270,
              rank: 886,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 1200000000,
              rank: 869,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2683777,
              rank: 211,
            },
            streams: {
              title: "Streams",
              value: 1109384927,
              rank: 635,
            },
            artistStations: {
              title: "Artist Stations",
              value: 2511774,
              rank: 784,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 672490,
              rank: 933,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 48810362,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 1916,
              rank: 1465,
            },
            likes: {
              title: "Likes",
              value: 11014,
              rank: 1137,
            },
            plays: {
              title: "Plays",
              value: 1155570,
              rank: 1145,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1330,
              rank: 663,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 3188,
              rank: 890,
            },
            likes: {
              title: "Likes",
              value: 32233,
              rank: 688,
            },
            videoLikes: {
              title: "Video Likes",
              value: 49,
              rank: 607,
            },
            videoViews: {
              title: "Video Views",
              value: 5173,
              rank: 602,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 14023863,
            },
          },
        },
      },
    },
  },
  {
    auctionID: 2183,
    symbolID: "BRN_USA",
    symbolType: "Part of an album",
    title: "Born in the U.S.A",
    genre: ["Rock", "POP", "Country"],
    description: `Bruce Springsteen's iconic songs like "Born in the USA," "Cover Me," "Darlington County," "Downbound Train," and "I'm Going Down" exemplify his musical prowess and
    storytelling ability. "Born in the USA" is a patriotic anthem with a poignant critique of veteran treatment. "Cover Me" is an energetic rock track exploring protection and
    shelter. "Darlington County" vividly portrays small-town longing. "Downbound Train" delves into loss and resilience, while "I'm Going Down" captures the pain of a failing
    relationship. Together, these songs showcase Springsteen's diverse songwriting skills and emotional depth.`,
    startDate: "05/12/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 100,
    minAuctionTarget: 300000,
    minOrder: 50,
    currentPrice: "$6.12",
    priceIncrease: "$0.02",
    averageYield: "4.0%",
    LTMYield: "5.0%",
    lastPrice: "$6.12",
    weeklyVolume: "461",
    change: "5.21%",
    dalyGain: "$3.5",
    totalGain: "$12.0",
    royalties: "$461",
    aveCost: "$5.21",
    orderType: "Auction",
    bidPerUnit: "9.55",
    bidUnits: "7",
    askPerUnit: "8.5",
    askUnits: "12.39",
    offlineUnits: "3,000",
    unitsValue: "$54,000",
    spotifyLink: "https://open.spotify.com/album/0PMasrHdpaoIRuHuhHp72O",
    imgSrc: ["auctions/the-street-band-1.jpg"],
    metrics: {
      spotify: 174480,
      instagram: 5640,
    },
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$100,000",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$80,000",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "4%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "39 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "20 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$2,000,000",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "BMI, ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Part of an album",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "5",
      },
      {
        title: "Record lable",
        description: "Columbia",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/EPhWR4d3FJQ",
        thumbnail: "tracks/born-video1.png",
      },
      {
        link: "https://www.youtube.com/embed/_7Qk9MdyiOM",
        thumbnail: "tracks/born-video2.png",
      },
      {
        link: "https://www.youtube.com/embed/-DQXxCfIS2w",
        thumbnail: "tracks/born-video3.png",
      },
      {
        link: "https://www.youtube.com/embed/Q80_LmmJWno",
        thumbnail: "tracks/born-video1.png",
      },
    ],
    tracks: [
      {
        id: "15812861",
        isrc: "USSM18400406",
        title: "Born in the U.S.A.",
        artist: "Bruce Springsteen",
        album: "Born in the U.S.A.",
        releaseDate: "12/31/1983",
        spotifyLink:
          "https://open.spotify.com/track/0dOg1ySSI7NkpAe89Zo0b9?si=b8ad1d1a46824111",
        imgSrc: "auctions/the-street-band-3.jpg",
        trackScore: {
          all: [
            {
              value: 14,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: -5,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 11,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 11,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 10,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: -4,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 3,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 12,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 12,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 12,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: -2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 12,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 12,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 12,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 15,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 14,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 42,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 34,
              },
              views: {
                title: "Views",
                value: 1810,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 188394,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 47173537,
              },
              trackStations: {
                title: "Track Stations",
                value: 149071,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 76,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 55967214,
              },
              streams: {
                title: "Streams",
                value: 390141996,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 90195011,
              },
              likes: {
                title: "Likes",
                value: 562053,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 1536257,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 1758480,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 431893,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 121276,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 53,
              },
            },
          },
        },
      },
      {
        id: "15812862",
        isrc: "USSM18400407",
        title: "Cover Me",
        artist: "Bruce Springsteen",
        album: "Born in the U.S.A.",
        releaseDate: "12/31/1983",
        spotifyLink:
          "https://open.spotify.com/track/4U7NhC2rQTAhH7dw7H0goB?si=7449cdcdba444ad3",
        imgSrc: "auctions/the-street-band-3.jpg",
        trackScore: {
          all: [
            {
              value: 5,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 4,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 5,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 8231482,
              },
              trackStations: {
                title: "Track Stations",
                value: 3085,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 58,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 2004312,
              },
              streams: {
                title: "Streams",
                value: 28560505,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 3920470,
              },
              likes: {
                title: "Likes",
                value: 18350,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 26044,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 396438,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 34115,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 15361,
              },
            },
          },
        },
      },
      {
        id: "15812863",
        isrc: "USSM18400408",
        title: "Darlington County",
        artist: "Bruce Springsteen",
        album: "Born in the U.S.A.",
        releaseDate: "12/31/1983",
        spotifyLink:
          "https://open.spotify.com/track/3O5RCjnjWlF0CYkcvJaGVm?si=e6887132ad3945e2",
        imgSrc: "auctions/the-street-band-3.jpg",
        trackScore: {
          all: [
            {
              value: 2,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 2,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 2,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 4457716,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 51,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 347473,
              },
              streams: {
                title: "Streams",
                value: 11212135,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1246600,
              },
              likes: {
                title: "Likes",
                value: 8542,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 35225,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 25421,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 1200,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 269,
              },
            },
          },
        },
      },
      {
        id: "15812869",
        isrc: "USSM18400414",
        title: `I'm Goin' Down`,
        artist: "Bruce Springsteen",
        album: "Born in the U.S.A.",
        releaseDate: "12/31/1983",
        spotifyLink:
          "https://open.spotify.com/track/0VkDedVtP7TQDlaCMq9QVx?si=649fc07d3d74458a",
        imgSrc: "auctions/the-street-band-3.jpg",
        trackScore: {
          all: [
            {
              value: 6,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 6,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 7,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 5,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: -2,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 7,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 16442,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 19426970,
              },
              trackStations: {
                title: "Track Stations",
                value: 5482,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 63,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 1962386,
              },
              streams: {
                title: "Streams",
                value: 34988607,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 36196594,
              },
              likes: {
                title: "Likes",
                value: 133604,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 82019,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 435658,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 6859,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 3803,
              },
            },
          },
        },
      },
      {
        id: "15812865",
        isrc: "USSM18400410",
        title: "Downbound Train",
        artist: "Bruce Springsteen",
        album: "Born in the U.S.A.",
        releaseDate: "12/31/1983",
        spotifyLink:
          "https://open.spotify.com/track/4a0oZYU2ntSUof4lkm2PCl?si=62eccd4a85f54e17",
        imgSrc: "auctions/the-street-band-3.jpg",
        trackScore: {
          all: [
            {
              value: 3,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 3,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 3,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 6759989,
              },
              trackStations: {
                title: "Track Stations",
                value: 2643,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 58,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 507692,
              },
              streams: {
                title: "Streams",
                value: 19436817,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 3781836,
              },
              likes: {
                title: "Likes",
                value: 13633,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 37741,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 151403,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 961,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 929,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://variety.com/2023/music/news/power-of-women-2023-music-executives-impact-1235569511/",
        title:
          "Power of Women 2023: The NY-Based Female Music Executives Making an Impact",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-31T00:12:13.000Z",
      },
      {
        url: "https://www.rollingstone.com/music/music-features/eddie-manion-bruce-springsteen-sax-player-1234696607/",
        title:
          "Eddie Manion’s Five-Decade Odyssey as Bruce Springsteen’s Other Sax Player",
        source: "Rolling Stone",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Rolling_Stone_2019.svg/180px-Rolling_Stone_2019.svg.png",
        date: "2023-03-27T14:00:00.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/bruce-springsteen-resumes-tour-philadelphia-illness-1235557718/",
        title:
          "Bruce Springsteen Resumes Tour With Rousing Philadelphia Concert, and No Mention of ‘Illness’",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-17T17:26:32.000Z",
      },
      {
        url: "https://www.rollingstone.com/music/music-news/patti-smith-shes-leaving-home-paul-mccartney-tribute-concert-1234697968/",
        title:
          "Watch Patti Smith’s Stunning Rendition of ‘She’s Leaving Home’ at Paul McCartney Tribute Concert",
        source: "Rolling Stone",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Rolling_Stone_2019.svg/180px-Rolling_Stone_2019.svg.png",
        date: "2023-03-16T16:23:16.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/pink-floyd-500-million-catalog-sale-dead-or-not-1235549360/",
        title:
          "Pink Floyd’s $500 Million Catalog Sale Is ‘Basically Dead’ — Or Is It?",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-14T13:55:04.000Z",
      },
      {
        url: "https://www.rollingstone.com/music/music-features/miley-cyrus-best-and-worst-albums-1234695639/",
        title: "Miley’s Weird Journey: From ‘Hannah Montana’ to ‘Flowers’",
        source: "Rolling Stone",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Rolling_Stone_2019.svg/180px-Rolling_Stone_2019.svg.png",
        date: "2023-03-13T16:45:31.000Z",
      },
      {
        url: "https://www.billboard.com/music/music-news/bruce-springsteen-e-street-band-postpones-march-2023-concerts-illness-1235284338/",
        title:
          "Bruce Springsteen & E Street Band Postpones Several U.S. Concerts Due to Illness",
        source: "billboard",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
        date: "2023-03-12T20:06:07.000Z",
      },
      {
        url: "https://allrapnews.com/news/justin-bieber-200-million-deal-music-catalog/",
        title: "Justin Bieber Nears $200 Million Deal To Sell Music Catalog",
        source: "All Rap News",
        image_url:
          "https://allrapnews.com/wp-content/uploads/2021/08/111ARN-logo.png",
        date: "2022-12-23T13:11:34.000Z",
      },
      {
        url: "https://www.brooklynvegan.com/20-great-hardcore-releases-from-2022/",
        title: "20 Great Hardcore Releases from 2022",
        source: "Brooklyn Vegan",
        image_url:
          "https://townsquare.media/site/838/files/2017/10/bv-1logo-new1.png",
        date: "2022-12-22T14:00:44.000Z",
      },
      {
        url: "https://raptology.com/news/justin-bieber-200-million-deal-music-catalog/?utm_source=rss&utm_medium=rss&utm_campaign=justin-bieber-200-million-deal-music-catalog",
        title: "Justin Bieber Nears $200 Million Deal To Sell Music Catalog",
        source: "Raptology",
        image_url: "https://raptology.com/wp-content/uploads/2021/08/logox.png",
        date: "2022-12-22T13:47:54.000Z",
      },
      {
        url: "https://variety.com/2022/music/news/justin-bieber-200-million-sell-music-rights-1235467545/",
        title:
          "Justin Bieber Close to $200 Million Deal to Sell His Music Rights",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2022-12-21T20:52:16.000Z",
      },
    ],
    artist: {
      id: "",
      name: "Bruce Springsteen",
      biography: `"Born in the U.S.A." is a song written and performed by Bruce Springsteen, and released in 1984 on the album of the same name. One of Springsteen's best-known singles, it
      was ranked 275th on Rolling Stone's list of "The 500 Greatest Songs of All Time", and in 2001, the RIAA's Songs of the Century placed the song 59th (out of 365), remaining a
      favorite in classic rock. The song addresses the economic hardships of Vietnam veterans upon their return home, juxtaposed ironically against patriotic glorification of the nation's
      fighting forces.`,
      career: {
        stage: "Legendary",
        socialMediaImpact: "Neutral",
        growth: "Growth",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5601893,
              rank: 446,
              monthly_diff: {
                value: 63995,
                percentage: 1.1556,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 700000000,
              rank: 367,
            },
            popularity: {
              title: "Popularity",
              value: 76,
              rank: 444,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 195624879,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "33.13%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "34.92x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 1482125,
              rank: 4824,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            topVideoViews: {
              title: "Top Video Views",
              value: 46832343,
              rank: 26012,
            },
            postCount: {
              title: "Post Count",
              value: 19214,
              rank: 31177,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 1890000,
              rank: 2646,
              monthly_diff: {
                value: 20000,
                percentage: 1.0695,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2012746557,
              rank: 956,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1046144,
              rank: 925,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 170000000,
              rank: 812,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 1406564,
              rank: 628,
            },
            streams: {
              title: "Streams",
              value: 891679588,
              rank: 776,
            },
            artistStations: {
              title: "Artist Stations",
              value: 5827243,
              rank: 341,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 1434815,
              rank: 391,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 33968595,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 8408969,
            },
          },
        },
      },
    },
  },
  {
    auctionID: 8976,
    symbolID: "THS1_FRU",
    symbolType: "Album",
    title: `This One's for You`,
    genre: ["Country"],
    description: `Luke Combs' album "This One's for You" is a country music masterpiece that captivates listeners with its heartfelt lyrics, raw emotion, and infectious melodies. Released in
    2017, the album showcases Combs' distinctive baritone voice and his ability to craft relatable songs that resonate with fans from all walks of life. From the anthemic and
    empowering "Hurricane" to the tender and introspective "One Number Away," Combs effortlessly blends traditional country elements with a modern sensibility, creating a
    sound that is both timeless and fresh.`,
    startDate: "05/12/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 100,
    minAuctionTarget: 300000,
    minOrder: 50,
    currentPrice: "$12.65",
    priceIncrease: "$0.15",
    averageYield: "7.0%",
    LTMYield: "9.0%",
    lastPrice: "$12.65",
    weeklyVolume: "53",
    change: "0.05%",
    dalyGain: "$3.5",
    totalGain: "$11.06",
    royalties: "$53",
    aveCost: "$2.41",
    orderType: "Limit",
    bidPerUnit: "8.01",
    bidUnits: "12",
    askPerUnit: "7.98",
    askUnits: "12.39",
    spotifyLink: "https://open.spotify.com/album/1lhNch5NkOONvFhRPh8qaj",
    imgSrc: ["auctions/this-ones-for-you.jpg"],
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$45,000",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$35,000",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "9",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "7%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "7 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.1 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$500,000",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "ASCAP/ River House Artists/Colombia Nashville",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Part of an album",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "5",
      },
      {
        title: "Record lable",
        description: "River House Artists/Columbia Nashville",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/uXyxFMbqKYA",
        thumbnail: "tracks/when-it-rains.png",
      },
      {
        link: "https://www.youtube.com/embed/BixwVsiDdZM",
        thumbnail: "tracks/hurracaine.png",
      },
      {
        link: "https://www.youtube.com/embed/Ct9BFr9XBaI",
        thumbnail: "tracks/one-number.png",
      },
      {
        link: "https://www.youtube.com/embed/ukvBuyRPQDI",
        thumbnail: "tracks/one-number.png",
      },
    ],
    tracks: [
      {
        id: "13967820",
        isrc: "QZ4751600015",
        title: "When It Rains It Pours",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "06/01/2017",
        spotifyLink:
          "https://open.spotify.com/track/52SVFJkssH5BLT9ZJDTTZZ?si=c242fb77a7d147d2",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 63585,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 182,
              interpolated: false,
            },
            {
              value: 63753,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 168,
              interpolated: false,
            },
            {
              value: 63984,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 231,
              interpolated: false,
            },
            {
              value: 64145,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 161,
              interpolated: false,
            },
            {
              value: 64284,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 139,
              interpolated: false,
            },
            {
              value: 64398,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 114,
              interpolated: false,
            },
            {
              value: 64532,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 134,
              interpolated: false,
            },
            {
              value: 64670,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 138,
              interpolated: false,
            },
            {
              value: 64809,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 139,
              interpolated: false,
            },
            {
              value: 64935,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 126,
              interpolated: false,
            },
            {
              value: 65041,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 106,
              interpolated: false,
            },
            {
              value: 65175,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 134,
              interpolated: false,
            },
            {
              value: 65298,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 123,
              interpolated: false,
            },
            {
              value: 65419,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 121,
              interpolated: false,
            },
            {
              value: 65557,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 138,
              interpolated: false,
            },
            {
              value: 65672,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 115,
              interpolated: false,
            },
            {
              value: 65769,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 97,
              interpolated: false,
            },
            {
              value: 65889,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 120,
              interpolated: false,
            },
            {
              value: 65987,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 98,
              interpolated: false,
            },
            {
              value: 66128,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 141,
              interpolated: false,
            },
            {
              value: 66276,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 148,
              interpolated: false,
            },
            {
              value: 66397,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 121,
              interpolated: false,
            },
            {
              value: 66586,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 189,
              interpolated: false,
            },
            {
              value: 66695,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 109,
              interpolated: false,
            },
            {
              value: 66861,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 166,
              interpolated: false,
            },
            {
              value: 67017,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 156,
              interpolated: false,
            },
            {
              value: 67151,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 134,
              interpolated: false,
            },
            {
              value: 67284,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 133,
              interpolated: false,
            },
            {
              value: 67404,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 120,
              interpolated: false,
            },
            {
              value: 67579,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 175,
              interpolated: false,
            },
            {
              value: 67720,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 141,
              interpolated: false,
            },
            {
              value: 67835,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 115,
              interpolated: false,
            },
            {
              value: 67881,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 46,
              interpolated: false,
            },
            {
              value: 67979,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 98,
              interpolated: false,
            },
            {
              value: 68118,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 139,
              interpolated: false,
            },
            {
              value: 68225,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 107,
              interpolated: false,
            },
            {
              value: 68360,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 135,
              interpolated: false,
            },
            {
              value: 68484,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 124,
              interpolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 325,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 23825,
              },
              likes: {
                title: "Likes",
                value: 4725351,
              },
              views: {
                title: "Views",
                value: 47039905,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 1234619,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 293399303,
              },
              trackStations: {
                title: "Track Stations",
                value: 119440,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 83,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 17110524,
              },
              streams: {
                title: "Streams",
                value: 595202180,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 498403807,
              },
              likes: {
                title: "Likes",
                value: 1867654,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 164994,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 1532536,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 27518,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 114751,
              },
            },
          },
        },
      },
      {
        id: "14341351",
        isrc: "TCACJ1540988",
        title: "Hurricane",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "11/26/2015",
        spotifyLink:
          "https://open.spotify.com/track/2flKprTJaGQQxSJkr2bR9S?si=e9d4b60630744483",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 1069,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1071,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1073,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1074,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1076,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1077,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1079,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1081,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1081,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1082,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1082,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1083,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1083,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1083,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1083,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1084,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1084,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1087,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 3,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1089,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1089,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1091,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1091,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1092,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1092,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1094,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1095,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1095,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1095,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1095,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1097,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1096,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: -1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1097,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1097,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1097,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1098,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1098,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1100,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 1101,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 253,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 98207,
              },
              likes: {
                title: "Likes",
                value: 18018013,
              },
              views: {
                title: "Views",
                value: 148397681,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 1342787,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 403152951,
              },
              trackStations: {
                title: "Track Stations",
                value: 136755,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 79,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 9608783,
              },
              streams: {
                title: "Streams",
                value: 567946315,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 124888756,
              },
              likes: {
                title: "Likes",
                value: 638301,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 160475,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 1507995,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 42969,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 73639,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 56,
              },
            },
          },
        },
      },
      {
        id: "13967818",
        isrc: "QZ4751600013",
        title: "One Number Away",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "05/18/2017",
        spotifyLink:
          "https://open.spotify.com/track/5zFdzpe4zKpD3gY0N1K0lV?si=e91fed363187412d",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 29849,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 74,
              interpolated: false,
            },
            {
              value: 29934,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 85,
              interpolated: false,
            },
            {
              value: 30051,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 117,
              interpolated: false,
            },
            {
              value: 30108,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 57,
              interpolated: false,
            },
            {
              value: 30172,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 64,
              interpolated: false,
            },
            {
              value: 30223,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 51,
              interpolated: false,
            },
            {
              value: 30275,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 52,
              interpolated: false,
            },
            {
              value: 30349,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 74,
              interpolated: false,
            },
            {
              value: 30400,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 51,
              interpolated: false,
            },
            {
              value: 30463,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 63,
              interpolated: false,
            },
            {
              value: 30511,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 48,
              interpolated: false,
            },
            {
              value: 30553,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 42,
              interpolated: false,
            },
            {
              value: 30620,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 67,
              interpolated: false,
            },
            {
              value: 30663,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 43,
              interpolated: false,
            },
            {
              value: 30724,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 61,
              interpolated: false,
            },
            {
              value: 30774,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 50,
              interpolated: false,
            },
            {
              value: 30826,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 52,
              interpolated: false,
            },
            {
              value: 30873,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 47,
              interpolated: false,
            },
            {
              value: 30926,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 53,
              interpolated: false,
            },
            {
              value: 30975,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 49,
              interpolated: false,
            },
            {
              value: 31032,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 57,
              interpolated: false,
            },
            {
              value: 31082,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 50,
              interpolated: false,
            },
            {
              value: 31173,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 91,
              interpolated: false,
            },
            {
              value: 31228,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 55,
              interpolated: false,
            },
            {
              value: 31289,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 61,
              interpolated: false,
            },
            {
              value: 31366,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 77,
              interpolated: false,
            },
            {
              value: 31411,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 45,
              interpolated: false,
            },
            {
              value: 31460,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 49,
              interpolated: false,
            },
            {
              value: 31500,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 40,
              interpolated: false,
            },
            {
              value: 31588,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 88,
              interpolated: false,
            },
            {
              value: 31646,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 58,
              interpolated: false,
            },
            {
              value: 31692,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 46,
              interpolated: false,
            },
            {
              value: 31707,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 31767,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 60,
              interpolated: false,
            },
            {
              value: 31825,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 58,
              interpolated: false,
            },
            {
              value: 31889,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 64,
              interpolated: false,
            },
            {
              value: 31939,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 50,
              interpolated: false,
            },
            {
              value: 32003,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 64,
              interpolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 199,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 114784,
              },
              likes: {
                title: "Likes",
                value: 12445716,
              },
              views: {
                title: "Views",
                value: 89541257,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 751020,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 241660086,
              },
              trackStations: {
                title: "Track Stations",
                value: 61332,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 79,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 5275793,
              },
              streams: {
                title: "Streams",
                value: 310053435,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 189007964,
              },
              likes: {
                title: "Likes",
                value: 860207,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 104098,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 1427044,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 5493,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 99055,
              },
            },
          },
        },
      },
      {
        id: "13967822",
        isrc: "QZ4751600018",
        title: "I Got Away with You",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "06/01/2017",
        spotifyLink:
          "https://open.spotify.com/track/2PuzFFTPNazkNhNXwaY5Pj?si=a7bf592eca5541fd",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 7238,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7248,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7282,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 34,
              interpolated: false,
            },
            {
              value: 7293,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7306,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7316,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7329,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7340,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7352,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 7364,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 7377,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7383,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 6,
              interpolated: false,
            },
            {
              value: 7393,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7404,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7417,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7426,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 9,
              interpolated: false,
            },
            {
              value: 7436,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7450,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
            {
              value: 7466,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 7478,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 7493,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 7504,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7520,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 7534,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
            {
              value: 7546,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 7562,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 7573,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7586,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7603,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
            },
            {
              value: 7611,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 8,
              interpolated: false,
            },
            {
              value: 7621,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7631,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7632,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 1,
              interpolated: false,
            },
            {
              value: 7645,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7658,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7664,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 6,
              interpolated: false,
            },
            {
              value: 7675,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7689,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 43,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1173,
              },
              likes: {
                title: "Likes",
                value: 115540,
              },
              views: {
                title: "Views",
                value: 847318,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 91119,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 75387263,
              },
              trackStations: {
                title: "Track Stations",
                value: 7449,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 57,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 1710699,
              },
              streams: {
                title: "Streams",
                value: 53116130,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 22654240,
              },
              likes: {
                title: "Likes",
                value: 90548,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 51141,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4026,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 26,
              },
            },
          },
        },
      },
      {
        id: "13967821",
        isrc: "13967821",
        title: "Be Careful What You Wish For",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "06/01/2017",
        spotifyLink:
          "https://open.spotify.com/track/0dZxwPZlB1awNIvYbdULDH?si=75082f498d94476c",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 9115,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 5,
              interpolated: false,
            },
            {
              value: 9133,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 9165,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 32,
              interpolated: false,
            },
            {
              value: 9188,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 23,
              interpolated: false,
            },
            {
              value: 9207,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
            },
            {
              value: 9223,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 9241,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 9260,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
            },
            {
              value: 9276,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 9292,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 9310,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 9320,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 9330,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 9343,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 9353,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 9367,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
            {
              value: 9377,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 9398,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 21,
              interpolated: false,
            },
            {
              value: 9412,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
            {
              value: 9431,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
            },
            {
              value: 9448,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
            },
            {
              value: 9461,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 9483,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
            },
            {
              value: 9494,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 9505,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 9536,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 31,
              interpolated: false,
            },
            {
              value: 9552,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 9566,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
            {
              value: 9578,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 9600,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
            },
            {
              value: 9619,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
            },
            {
              value: 9631,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 9634,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 3,
              interpolated: false,
            },
            {
              value: 9643,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 9,
              interpolated: false,
            },
            {
              value: 9656,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 9667,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 9684,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
            },
            {
              value: 9699,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 40,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1437,
              },
              likes: {
                title: "Likes",
                value: 186431,
              },
              views: {
                title: "Views",
                value: 1638662,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 89318,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 63440652,
              },
              trackStations: {
                title: "Track Stations",
                value: 3383,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 60,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 1976017,
              },
              streams: {
                title: "Streams",
                value: 72070918,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 6119071,
              },
              likes: {
                title: "Likes",
                value: 23851,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 17927,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 46606,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 0,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 15,
              },
            },
          },
        },
      },
      {
        id: "14341353",
        isrc: "TCACJ1540991",
        title: "This One's for You",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "11/26/2015",
        spotifyLink:
          "https://open.spotify.com/track/0dZxwPZlB1awNIvYbdULDH?si=e895f13d03cf448e",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 8754,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8769,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8816,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 47,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8831,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8845,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8860,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8871,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8883,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8898,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8913,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8926,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8937,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8949,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8960,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8972,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8984,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 8999,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9016,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9026,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9041,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9059,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9068,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 9,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9091,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 23,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9107,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9126,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9148,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9157,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 9,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9172,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9190,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9205,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9215,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9226,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9231,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 5,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9241,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9256,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9268,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9284,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9300,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 39,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 2149,
              },
              likes: {
                title: "Likes",
                value: 1315005,
              },
              views: {
                title: "Views",
                value: 13426076,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 126195,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 74355886,
              },
              trackStations: {
                title: "Track Stations",
                value: 21308,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 59,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 2044112,
              },
              streams: {
                title: "Streams",
                value: 66705750,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 21420363,
              },
              likes: {
                title: "Likes",
                value: 78251,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 51262,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4026,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 382,
              },
            },
          },
        },
      },
      {
        id: "13967817",
        isrc: "QZ4751600012",
        title: "Lonely One",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "06/01/2017",
        spotifyLink:
          "https://open.spotify.com/track/1kPB8bSz6OyYtDR5OOMjbs?si=daf5d63629764b6f",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 7408,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7425,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
            },
            {
              value: 7464,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 39,
              interpolated: false,
            },
            {
              value: 7484,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 20,
              interpolated: false,
            },
            {
              value: 7499,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 7511,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 7524,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7542,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 7553,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7563,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7575,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 7584,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 9,
              interpolated: false,
            },
            {
              value: 7592,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 8,
              interpolated: false,
            },
            {
              value: 7600,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 8,
              interpolated: false,
            },
            {
              value: 7613,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7623,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7634,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7657,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 23,
              interpolated: false,
            },
            {
              value: 7672,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 7685,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7701,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 7712,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 7729,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
            },
            {
              value: 7748,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
            },
            {
              value: 7758,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
            },
            {
              value: 7776,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 7789,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7796,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 7,
              interpolated: false,
            },
            {
              value: 7809,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 7830,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 21,
              interpolated: false,
            },
            {
              value: 7844,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
            {
              value: 7859,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 7859,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 0,
              interpolated: false,
            },
            {
              value: 7864,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 5,
              interpolated: false,
            },
            {
              value: 7873,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 9,
              interpolated: false,
            },
            {
              value: 7881,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 8,
              interpolated: false,
            },
            {
              value: 7897,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 7911,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 26,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1405,
              },
              likes: {
                title: "Likes",
                value: 562925,
              },
              views: {
                title: "Views",
                value: 7127552,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 67945,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 35743772,
              },
              trackStations: {
                title: "Track Stations",
                value: 3059,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 57,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 2134738,
              },
              streams: {
                title: "Streams",
                value: 46488609,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 9731615,
              },
              likes: {
                title: "Likes",
                value: 40345,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 39415,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4026,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 160,
              },
            },
          },
        },
      },
      {
        id: "14341352",
        isrc: "TCACJ1540989",
        title: "Beer Can",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "11/26/2015",
        spotifyLink:
          "https://open.spotify.com/track/7yPzzkyO6xCTnDJBLbjImK?si=4693245d675e431a",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 12985,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 28,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13007,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13058,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 51,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13082,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 24,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13115,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 33,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13129,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13155,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 26,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13186,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 31,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13216,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 30,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13239,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 23,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13255,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13271,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13283,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13304,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 21,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13331,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 27,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13349,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13364,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13386,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13404,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13424,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 20,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13456,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 32,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13480,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 24,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13523,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 43,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13547,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 24,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13577,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 30,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13607,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 30,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13629,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13650,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 21,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13673,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 23,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13705,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 32,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13731,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 26,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13757,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 26,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13759,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 2,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13774,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13792,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13805,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13830,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 25,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 13859,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 29,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 26,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 26029,
              },
              likes: {
                title: "Likes",
                value: 6463837,
              },
              views: {
                title: "Views",
                value: 78269762,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 159449,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 27418093,
              },
              trackStations: {
                title: "Track Stations",
                value: 5176,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 62,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 2670343,
              },
              streams: {
                title: "Streams",
                value: 72499802,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 14131776,
              },
              likes: {
                title: "Likes",
                value: 64454,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 8441,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 76285,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4026,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 91,
              },
            },
          },
        },
      },
      {
        id: "14341349",
        isrc: "TCACJ1540979",
        title: "Memories Are Made Of",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "11/26/2015",
        spotifyLink:
          "https://open.spotify.com/track/5fEMUbdy1kci579wHegeHq?si=a058378f2cf04653",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 9130,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9158,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 28,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9194,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 36,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9207,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9220,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9233,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9255,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9268,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9281,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9298,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9314,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9327,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9339,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9355,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9370,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9384,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9390,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 6,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9410,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 20,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9426,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9441,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9460,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9470,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9495,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 25,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9521,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 26,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9531,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 10,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9560,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 29,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9574,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9590,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9605,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9626,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 21,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9645,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9662,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9665,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 3,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9674,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 9,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9689,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9698,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 9,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9718,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 20,
              interpolated: false,
              extrapolated: false,
            },
            {
              value: 9735,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
              extrapolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 25,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 13916,
              },
              likes: {
                title: "Likes",
                value: 929805,
              },
              views: {
                title: "Views",
                value: 8948725,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 117236,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 37250670,
              },
              trackStations: {
                title: "Track Stations",
                value: 3459,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 57,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 2108497,
              },
              streams: {
                title: "Streams",
                value: 61735065,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 7678551,
              },
              likes: {
                title: "Likes",
                value: 30793,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 45143,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4385,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 27,
              },
            },
          },
        },
      },
      {
        id: "14341348",
        isrc: "TCACJ1540975",
        title: "Out There",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "11/26/2015",
        spotifyLink:
          "https://open.spotify.com/track/6eO8bUr6vsBKuA6nLfsvUY?si=66501064301a4a64",
        imgSrc: "auctions/this-ones-for-you.jpg",
        trackScore: {
          all: [
            {
              value: 8527,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 8540,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 8580,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 40,
              interpolated: false,
            },
            {
              value: 8600,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 20,
              interpolated: false,
            },
            {
              value: 8618,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 8631,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 8645,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
            {
              value: 8663,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 8674,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 8696,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
            },
            {
              value: 8711,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 8731,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 20,
              interpolated: false,
            },
            {
              value: 8746,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 8765,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
            },
            {
              value: 8783,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 8799,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 8813,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 14,
              interpolated: false,
            },
            {
              value: 8836,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 23,
              interpolated: false,
            },
            {
              value: 8853,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 17,
              interpolated: false,
            },
            {
              value: 8875,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
            },
            {
              value: 8897,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 22,
              interpolated: false,
            },
            {
              value: 8912,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 8939,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 27,
              interpolated: false,
            },
            {
              value: 8955,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 8975,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 20,
              interpolated: false,
            },
            {
              value: 9002,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 27,
              interpolated: false,
            },
            {
              value: 9018,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 16,
              interpolated: false,
            },
            {
              value: 9044,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 26,
              interpolated: false,
            },
            {
              value: 9063,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 19,
              interpolated: false,
            },
            {
              value: 9088,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 25,
              interpolated: false,
            },
            {
              value: 9106,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
            {
              value: 9127,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 21,
              interpolated: false,
            },
            {
              value: 9131,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 4,
              interpolated: false,
            },
            {
              value: 9143,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 12,
              interpolated: false,
            },
            {
              value: 9156,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 13,
              interpolated: false,
            },
            {
              value: 9167,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 11,
              interpolated: false,
            },
            {
              value: 9182,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 15,
              interpolated: false,
            },
            {
              value: 9200,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 18,
              interpolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 20,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 927,
              },
              likes: {
                title: "Likes",
                value: 239957,
              },
              views: {
                title: "Views",
                value: 2405562,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 93778,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 31291307,
              },
              trackStations: {
                title: "Track Stations",
                value: 6650,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 55,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 1811861,
              },
              streams: {
                title: "Streams",
                value: 47697304,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 5451920,
              },
              likes: {
                title: "Likes",
                value: 24635,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 24121,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 43,
              },
            },
          },
        },
      },
      {
        id: "13967823",
        isrc: "13967823",
        title: "Honky Tonk Highway",
        artist: "Luke Combs",
        album: "This One's for You",
        releaseDate: "06/01/2017",
        spotifyLink:
          "https://open.spotify.com/track/0QbWwumrkFzbUx6m6GcUOF?si=13ab8ba4db0b40ea",
        imgSrc: "auctions/this-ones-for-you.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 17,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1106,
              },
              likes: {
                title: "Likes",
                value: 269486,
              },
              views: {
                title: "Views",
                value: 3120055,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 77275,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 9353954,
              },
              trackStations: {
                title: "Track Stations",
                value: 1323,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 57,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 2321208,
              },
              streams: {
                title: "Streams",
                value: 45625774,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 5747677,
              },
              likes: {
                title: "Likes",
                value: 22464,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 46262,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4026,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 37,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://variety.com/2023/music/news/taylor-swift-iheartradio-awards-phoebe-bridgers-pink-lenny-kravitz-1235566235/",
        title:
          "All Hail Taylor Swift at 2023 iHeartRadio Awards as Pink Previews Summer Tour and Lenny Kravitz Rocks the House",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-28T06:33:54.000Z",
      },
      {
        url: "https://www.billboard.com/music/music-news/ed-sheeran-lana-del-rey-new-music-poll-1235292301/",
        title:
          "Ed Sheeran, Lana Del Rey, Luke Combs & More: Which Music Release Is Your Favorite? Vote!",
        source: "billboard",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
        date: "2023-03-24T20:05:15.000Z",
      },
      {
        url: "https://www.billboard.com/music/chart-beat/morgan-wallen-ninth-week-no-1-artist-100-1235290832/",
        title: "Morgan Wallen Scores Ninth Week at No. 1 on Artist 100 Chart",
        source: "billboard",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
        date: "2023-03-21T19:48:22.000Z",
      },
      {
        url: "https://www.rollingstone.com/music/music-features/songs-you-need-to-know-this-week-taylor-swift-jimin-1234697928/",
        title:
          "Taylor Swift, Jimin, Lana Del Rey and All The Songs You Need To know This Week",
        source: "Rolling Stone",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Rolling_Stone_2019.svg/180px-Rolling_Stone_2019.svg.png",
        date: "2023-03-17T18:13:02.000Z",
      },
      {
        url: "https://www.nytimes.com/2023/03/17/arts/music/playlist-taylor-swift-100-gecs.html",
        title: "Taylor Swift’s ‘Lover’ Outtake, and 8 More New Songs",
        source: "New York Times",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/NewYorkTimes.svg/250px-NewYorkTimes.svg.png",
        date: "2023-03-17T16:16:52.000Z",
      },
      {
        url: "https://www.billboard.com/pro/morgan-wallen-record-top-nine-spots-hot-country-songs-chart/",
        title:
          "Morgan Wallen Claims Record Top 9 Spots on Hot Country Songs Chart",
        source: "billboard",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
        date: "2023-03-14T19:13:38.000Z",
      },
      {
        url: "https://chaospin.com/best-jenny-lewis-songs/",
        title: "The 10 Best Jenny Lewis Songs of All-Time",
        source: "Chaospin",
        image_url:
          "https://chaospin.com/wp-content/uploads/2021/05/rsz_chaospin-logo-2-1.jpg",
        date: "2023-03-09T12:22:36.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/cmt-awards-nominations-lainey-wilson-kane-brown-cody-johnson-jelly-roll-1235546580/",
        title:
          "CMT Music Awards Nominations Led by Lainey Wilson, Kane Brown, Cody Johnson, Jelly Roll",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-08T14:22:03.000Z",
      },
      {
        url: "https://www.rollingstone.com/music/music-country/2023-cmt-music-awards-nominations-lainey-wilson-1234692321/",
        title: "Lainey Wilson Leads 2023 CMT Music Awards Nominations",
        source: "Rolling Stone",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Rolling_Stone_2019.svg/180px-Rolling_Stone_2019.svg.png",
        date: "2023-03-08T14:06:15.000Z",
      },
      {
        url: "https://www.digitalmusicnews.com/2023/03/07/guild-of-music-supervisors-gms-awards-2023-winners/",
        title:
          "The Guild of Music Supervisors Awards Return In Fiery Fashion to LA — Here’s the Complete Winners List",
        source: "Digital Music News",
        image_url:
          "https://www.digitalmusicnews.com/wp-content/uploads/2016/01/DMN_Logo_340-1.png",
        date: "2023-03-08T02:28:40.000Z",
      },
    ],
    artist: {
      id: 207759,
      name: "Luke Combs",
      biography: `Blending a love of classic country and Southern-fried soul -- a fusion inspired equally by fellow modern mavericks Eric Church and Chris Stapleton -- Luke Combs slyly
      updates these traditional sounds with a hint of modern R&B. This combination, which flourished on ballads, made Combs stand apart from both slick country-pop crooners
      and bro-country revelers, a distinction that helped him become a hit right out of the gate. His first single, 2016's "Hurricane," launched a series of five number one
      Billboard`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Excellent",
        growth: "Growth",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 8573619,
              rank: 235,
              monthly_diff: {
                value: 147024,
                percentage: 1.7448,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 1200000000,
              rank: 245,
            },
            popularity: {
              title: "Popularity",
              value: 85,
              rank: 69,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 97908521,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "39.06%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "11.42",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5242970,
              rank: 1464,
              monthly_diff: {
                value: 92039,
                percentage: 1.7868,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 4600000,
              rank: 688,
              monthly_diff: {
                value: 100000,
                percentage: 2.2222,
              },
            },
            likes: {
              title: "Likes",
              value: 41700000,
              rank: 1170,
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 2831735983,
              rank: 853,
            },
            postCount: {
              title: "Post Count",
              value: 1819034,
              rank: 1209,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 3090000,
              rank: 1567,
              monthly_diff: {
                value: 30000,
                percentage: 0.9804,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 3660150107,
              rank: 468,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 2567008,
              rank: 305,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 700000000,
              rank: 329,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 9049054,
              rank: 3,
            },
            streams: {
              title: "Streams",
              value: 5009063485,
              rank: 74,
            },
            artistStations: {
              title: "Artist Stations",
              value: 8110259,
              rank: 219,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 201672,
              rank: 2655,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 18908396,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/genius.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 662,
              rank: 1713,
            },
            likes: {
              title: "Likes",
              value: 6874,
              rank: 1226,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 1962806,
            },
          },
        },
      },
    },
  },
  {
    auctionID: 1108,
    symbolID: "",
    symbolType: "Part of an album",
    title: "Godzilla",
    genre: ["Rap", "Hip-Hop"],
    description: `"Godzilla" is an electrifying collaboration between Eminem and the late Juice WRLD, released in 2020 as part of Eminem's album "Music to be Murdered By." The song
    showcases the explosive rap prowess of both artists, combining Eminem's rapid-fire delivery and Juice WRLD's melodic sensibilities. With its high-energy production and
    intense lyricism, "Godzilla" captivates listeners from the very first beat. The track's title is a metaphorical nod to the monstrous and unstoppable nature of their skills, as they
    effortlessly maneuver through intricate wordplay and slick rhymes. The late Juice WRLD's memorable chorus adds a touch of melodic vulnerability to the song, creating a
    dynamic contrast with Eminem's fierce and relentless verses. "Godzilla" stands as a testament to the incredible talent and artistic synergy between these two influential artists,
    leaving a lasting impact on the world of hip-hop.`,
    startDate: "05/12/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 300000,
    minAuctionTarget: 300000,
    minOrder: 50,
    currentPrice: "$14.35",
    targetPricePerUnit: "$10",
    status: "finished",/*"progress",*/
    spotifyLink:
      "https://open.spotify.com/track/7FIWs0pqAYbP91WWM0vlTQ?si=45d1389f0fdd40b3",
    imgSrc: ["auctions/godzilla.jpg"],
    metrics: {
      spotify: 174480,
      instagram: 5640,
    },
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$70,000",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$120,000",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "6%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "9%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "16.7 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,166,667",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "Shady",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Single",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "1",
      },
      {
        title: "Record lable",
        description: "Shady/Aftermath/Interscope",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/r_0JjYUe5jo",
        thumbnail: "tracks/godzilla-video2.png",
      },
    ],
    tracks: [
      {
        id: "28213841",
        isrc: "USUM72000788",
        title: "Godzilla",
        artist: "Eminem,Juice WRLD",
        album: "-- --",
        releaseDate: "01/17/2020",
        imgSrc: "tracks/godzilla.png",
        spotifyLink:
          "https://open.spotify.com/track/7FIWs0pqAYbP91WWM0vlTQ?si=45d1389f0fdd40b3",
        trackScore: {
          all: [
            {
              value: 229517,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 402,
              interpolated: false,
            },
            {
              value: 229905,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 388,
              interpolated: false,
            },
            {
              value: 230224,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 319,
              interpolated: false,
            },
            {
              value: 230594,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 370,
              interpolated: false,
            },
            {
              value: 230899,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 305,
              interpolated: false,
            },
            {
              value: 231203,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 304,
              interpolated: false,
            },
            {
              value: 231578,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 375,
              interpolated: false,
            },
            {
              value: 231896,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 318,
              interpolated: false,
            },
            {
              value: 232244,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 348,
              interpolated: false,
            },
            {
              value: 232568,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 324,
              interpolated: false,
            },
            {
              value: 232826,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 258,
              interpolated: false,
            },
            {
              value: 233139,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 313,
              interpolated: false,
            },
            {
              value: 233459,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 320,
              interpolated: false,
            },
            {
              value: 233755,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 296,
              interpolated: false,
            },
            {
              value: 234126,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 371,
              interpolated: false,
            },
            {
              value: 234403,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 277,
              interpolated: false,
            },
            {
              value: 234701,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 298,
              interpolated: false,
            },
            {
              value: 235020,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 319,
              interpolated: false,
            },
            {
              value: 235342,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 322,
              interpolated: false,
            },
            {
              value: 235679,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 337,
              interpolated: false,
            },
            {
              value: 236007,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 328,
              interpolated: false,
            },
            {
              value: 236340,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 333,
              interpolated: false,
            },
            {
              value: 236648,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 308,
              interpolated: false,
            },
            {
              value: 236998,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 350,
              interpolated: false,
            },
            {
              value: 237334,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 336,
              interpolated: false,
            },
            {
              value: 237634,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 300,
              interpolated: false,
            },
            {
              value: 237946,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 312,
              interpolated: false,
            },
            {
              value: 238245,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 299,
              interpolated: false,
            },
            {
              value: 238580,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 335,
              interpolated: false,
            },
            {
              value: 238885,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 305,
              interpolated: false,
            },
            {
              value: 239181,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 296,
              interpolated: false,
            },
            {
              value: 239396,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 215,
              interpolated: false,
            },
            {
              value: 239643,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 247,
              interpolated: false,
            },
            {
              value: 239902,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 259,
              interpolated: false,
            },
            {
              value: 240185,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 283,
              interpolated: false,
            },
            {
              value: 240496,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 311,
              interpolated: false,
            },
            {
              value: 240731,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 235,
              interpolated: false,
            },
            {
              value: 241015,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 284,
              interpolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 880,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 152411,
              },
              likes: {
                title: "Likes",
                value: 26913797,
              },
              views: {
                title: "Views",
                value: 216634323,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 41572286,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 129558480,
              },
              trackStations: {
                title: "Track Stations",
                value: 212766,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 84,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 45529171,
              },
              streams: {
                title: "Streams",
                value: 1148274402,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 908874692,
              },
              likes: {
                title: "Likes",
                value: 14061158,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 6492134,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 2608651,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 457567,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 19098,
              },
              count: {
                title: "Listen Count",
                value: 1658281,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 44053,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 41547,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://www.okayplayer.com/music/kurupt-eminem-the-art-of-dialogue.html",
        title:
          "Kurupt Says Eminem “Got Away” With Dissing Other Rappers Because of Race",
        source: "Okayplayer",
        image_url:
          "https://yt3.ggpht.com/ytc/AMLnZu9tabEaPKboW0n_5riHUHmVsHtycyBU6zvmlKnTpg=s88-c-k-c0x00ffffff-no-rj",
        date: "2023-03-30T20:41:45.000Z",
      },
      {
        url: "https://www.complex.com/music/kurupt-eminem-got-away-with-dissing-other-artists",
        title:
          "Kurupt Suggests Eminem ‘Got Away’ With Dissing Other Artists Because He’s White",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-30T19:03:42.000Z",
      },
      {
        url: "https://allrapnews.com/news/tyga-declares-nicki-minaj-the-best-female-rapper-of-all-time/?utm_source=rss&utm_medium=rss&utm_campaign=tyga-declares-nicki-minaj-the-best-female-rapper-of-all-time",
        title: "Tyga Declares Nicki Minaj The ‘Best Female Rapper Of All Time’",
        source: "All Rap News",
        image_url:
          "https://allrapnews.com/wp-content/uploads/2021/08/111ARN-logo.png",
        date: "2023-03-30T13:57:27.000Z",
      },
      {
        url: "https://modrnation.com/stories/a-conversation-with-cam-the-artisan-696l6",
        title: "A Conversation with Cam The Artisan",
        source: "modrNation",
        image_url:
          "https://images.squarespace-cdn.com/content/v1/5e9169c484583e265ab3057e/638c20f7-1d5a-4960-a739-ca6d767dc1ab/WEB+LOGO+PSD.png?format=1500w",
        date: "2023-03-29T02:12:11.000Z",
      },
      {
        url: "https://raptology.com/news/tyga-declares-lil-wayne-eminem-best-rappers/?utm_source=rss&utm_medium=rss&utm_campaign=tyga-declares-lil-wayne-eminem-best-rappers",
        title:
          "Tyga Declares Lil Wayne And Eminem The Best Rappers Of All Time",
        source: "Raptology",
        image_url: "https://raptology.com/wp-content/uploads/2021/08/logox.png",
        date: "2023-03-27T13:54:51.000Z",
      },
      {
        url: "https://www.digitalmusicnews.com/2023/03/23/amr-songs-john-sebastian-catalog-deal/",
        title:
          "AMR Songs Announces Catalog Deal With The Lovin’ Spoonful’s John Sebastian: ‘One of the Most Prolific Songwriters and Artists in Music History’",
        source: "Digital Music News",
        image_url:
          "https://www.digitalmusicnews.com/wp-content/uploads/2016/01/DMN_Logo_340-1.png",
        date: "2023-03-23T20:22:02.000Z",
      },
      {
        url: "https://www.complex.com/music/ceelo-green-falls-off-horse-shawty-lo-birthday-party",
        title:
          "Video Shows CeeLo Green Falling Off Horse While Entering Shawty Lo’s Birthday Party",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-23T16:40:20.000Z",
      },
      {
        url: "https://www.edmsauce.com/2023/03/22/these-are-the-best-edm-artists-of-all-time-according-to-chatgpt/",
        title:
          "These Are The Best EDM Artists of All Time According to ChatGPT",
        source: "EDM Sauce",
        image_url:
          "https://www.edmsauce.com/wp-content/uploads/2020/05/rsz_2logo.png",
        date: "2023-03-22T16:20:20.000Z",
      },
      {
        url: "https://www.okayplayer.com/music/rap-twitter-ranks-their-favorite-sneak-diss-lines-in-hip-hop-history.html",
        title:
          "Rap Twitter Ranks Their Favorite “Sneak” Diss Lines in Hip-Hop History",
        source: "Okayplayer",
        image_url:
          "https://yt3.ggpht.com/ytc/AMLnZu9tabEaPKboW0n_5riHUHmVsHtycyBU6zvmlKnTpg=s88-c-k-c0x00ffffff-no-rj",
        date: "2023-03-21T16:12:38.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/ai-copyright-human-artistry-campaign-musicians-songwriters-artificial-intelligence-1235557582/",
        title:
          "AI and Copyright: Human Artistry Campaign Launches to Support Songwriters and Musicians’ Rights",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-17T14:17:52.000Z",
      },
    ],
    artist: {
      id: 236,
      name: "Eminem, juice WARLD",
      biography: `Eminem is one of the best-selling artists in music history, and easily one of rap's biggest crossover successes. He was the first white rapper 
      since the Beastie Boys to garner both sales and critical respect, but his impact has exceeded this confining distinction. On sheer technical skills, Eminem 
      is one of the greatest MCs of his generation: rapid, fluid, dexterous, and unpredictable, capable of pulling off long-form narratives or withering asides. 
      And thanks to his mentor Dr. Dre , he's had music to match: thick, muscular loops evoking the terror and paranoia conjured by his lyrics. To be certain, a 
      great deal of the controversy Eminem courted -- during the turn of the millennium, there was no greater pop culture bogeyman than Marshall Mathers -- came 
      through in how his violent fantasias, often directed at his mother or his wife, intertwined with flights of absurdity that appealed to listeners too young 
      to absorb the psychodramas Eminem explored on his hit albums The Slim Shady LP and The Marshall Mathers LP. With hits "My Name Is" and "The Real Slim Shady," 
      he ruled the airwaves, but it wasn't long before some detractors acknowledged his depth, helped in part by singles like the mournful "Stan," written from the 
      perspective of an obsessed fan. Eminem's commercial peak came around the time of his 2002 album The Eminem Show (which went platinum 27 times over) and with 
      his crossover onto the big screen that same year with 8 Mile, a film that earned him acclaim for his performance and an Oscar for the film's anthem, 
      "Lose Yourself." A number of demons have led him to withdraw periodically, but he's always returned with mid-career rejuvenations like 2009's Relapse 
      or 2020's Music to Be Murdered By.`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Neutral",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 71284327,
              rank: 8,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 66565080,
              rank: 13,
            },
            popularity: {
              title: "Popularity",
              value: 90,
              rank: 16,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 40910031,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "107.09%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "5.26x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 39116849,
              rank: 101,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            topVideoViews: {
              title: "Top Video Views",
              value: 11844762141,
              rank: 122,
            },
            postCount: {
              title: "Post Count",
              value: 7132045,
              rank: 218,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 56500000,
              rank: 13,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 26676144258,
              rank: 28,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 14871406,
              rank: 20,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 422374151,
              rank: 19,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 6405738,
              rank: 16,
            },
            streams: {
              title: "Streams",
              value: 13046140412,
              rank: 4,
            },
            artistStations: {
              title: "Artist Stations",
              value: 55117472,
              rank: 3,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 16322521,
              rank: 4,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 172955952,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 74184,
              rank: 248,
            },
            likes: {
              title: "Likes",
              value: 217749,
              rank: 261,
            },
            plays: {
              title: "Plays",
              value: 24900626,
              rank: 252,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 9335,
              rank: 330,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 47246,
              rank: 131,
            },
            likes: {
              title: "Likes",
              value: 279721,
              rank: 188,
            },
            videoLikes: {
              title: "Video Likes",
              value: 2956,
              rank: 200,
            },
            videoViews: {
              title: "Video Views",
              value: 469680,
              rank: 163,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 230842438,
            },
          },
        },
      },
    },
  },
  {
    auctionID: 3428,
    symbolID: "",
    symbolType: "Single",
    title: "HUMBLE",
    genre: ["Rap", "Hip-Hop"],
    description: `"HUMBLE." is a standout track by Kendrick Lamar, released in 2017 as part of his critically acclaimed album "DAMN." The song became an instant hit and a cultural
    phenomenon, showcasing Lamar's unparalleled artistry and his ability to deliver thought-provoking messages through his music. With its powerful production, infectious
    beats, and Kendrick's commanding flow, "HUMBLE." commands attention from the very first note. Lyrically, the song delves into themes of self-reflection, personal growth,
    and the pitfalls of fame and ego. Kendrick's razor-sharp lyrics challenge listeners to examine their own values and the state of the world, urging them to stay humble and true
    to themselves amidst societal pressures.`,
    startDate: "06/05/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 148248,
    minAuctionTarget: 1482485,
    minOrder: 50,
    currentPrice: "$10",
    targetPricePerUnit: "$10",
    status: "finished",/*"upcoming",*/
    spotifyLink:
      "https://open.spotify.com/track/7KXjTSCq5nL1LoYtL7XAwS?si=ec67747eba7b48e0",
    metrics: {
      spotify: 174480,
      instagram: 5640,
    },
    imgSrc: ["auctions/humble.webp"],
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$423,567",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$374,456",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "5.0%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "4%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "20.0 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$8,471,340",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Single",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "1",
      },
      {
        title: "Record lable",
        description: "Digital Distribution Trinidad and Tobago",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/tvTRZJ-4EyI",
        thumbnail: "tracks/humble-video.png",
      },
    ],
    tracks: [
      {
        id: "15940429",
        isrc: "USUM71703085",
        title: "HUMBLE",
        artist: "Kendrick Lamar",
        album: "-- --",
        releaseDate: "03/30/2017",
        spotifyLink:
          "https://open.spotify.com/track/7KXjTSCq5nL1LoYtL7XAwS?si=ec67747eba7b48e0",
        imgSrc: "tracks/humble.png",
        trackScore: {
          all: [
            {
              value: 229517,
              timestp: "2023-05-01T00:00:00.000Z",
              daily_diff: 402,
              interpolated: false,
            },
            {
              value: 229905,
              timestp: "2023-05-02T00:00:00.000Z",
              daily_diff: 388,
              interpolated: false,
            },
            {
              value: 230224,
              timestp: "2023-05-03T00:00:00.000Z",
              daily_diff: 319,
              interpolated: false,
            },
            {
              value: 230594,
              timestp: "2023-05-04T00:00:00.000Z",
              daily_diff: 370,
              interpolated: false,
            },
            {
              value: 230899,
              timestp: "2023-05-05T00:00:00.000Z",
              daily_diff: 305,
              interpolated: false,
            },
            {
              value: 231203,
              timestp: "2023-05-06T00:00:00.000Z",
              daily_diff: 304,
              interpolated: false,
            },
            {
              value: 231578,
              timestp: "2023-05-07T00:00:00.000Z",
              daily_diff: 375,
              interpolated: false,
            },
            {
              value: 231896,
              timestp: "2023-05-08T00:00:00.000Z",
              daily_diff: 318,
              interpolated: false,
            },
            {
              value: 232244,
              timestp: "2023-05-09T00:00:00.000Z",
              daily_diff: 348,
              interpolated: false,
            },
            {
              value: 232568,
              timestp: "2023-05-10T00:00:00.000Z",
              daily_diff: 324,
              interpolated: false,
            },
            {
              value: 232826,
              timestp: "2023-05-11T00:00:00.000Z",
              daily_diff: 258,
              interpolated: false,
            },
            {
              value: 233139,
              timestp: "2023-05-12T00:00:00.000Z",
              daily_diff: 313,
              interpolated: false,
            },
            {
              value: 233459,
              timestp: "2023-05-13T00:00:00.000Z",
              daily_diff: 320,
              interpolated: false,
            },
            {
              value: 233755,
              timestp: "2023-05-14T00:00:00.000Z",
              daily_diff: 296,
              interpolated: false,
            },
            {
              value: 234126,
              timestp: "2023-05-15T00:00:00.000Z",
              daily_diff: 371,
              interpolated: false,
            },
            {
              value: 234403,
              timestp: "2023-05-16T00:00:00.000Z",
              daily_diff: 277,
              interpolated: false,
            },
            {
              value: 234701,
              timestp: "2023-05-17T00:00:00.000Z",
              daily_diff: 298,
              interpolated: false,
            },
            {
              value: 235020,
              timestp: "2023-05-18T00:00:00.000Z",
              daily_diff: 319,
              interpolated: false,
            },
            {
              value: 235342,
              timestp: "2023-05-19T00:00:00.000Z",
              daily_diff: 322,
              interpolated: false,
            },
            {
              value: 235679,
              timestp: "2023-05-20T00:00:00.000Z",
              daily_diff: 337,
              interpolated: false,
            },
            {
              value: 236007,
              timestp: "2023-05-21T00:00:00.000Z",
              daily_diff: 328,
              interpolated: false,
            },
            {
              value: 236340,
              timestp: "2023-05-22T00:00:00.000Z",
              daily_diff: 333,
              interpolated: false,
            },
            {
              value: 236648,
              timestp: "2023-05-23T00:00:00.000Z",
              daily_diff: 308,
              interpolated: false,
            },
            {
              value: 236998,
              timestp: "2023-05-24T00:00:00.000Z",
              daily_diff: 350,
              interpolated: false,
            },
            {
              value: 237334,
              timestp: "2023-05-25T00:00:00.000Z",
              daily_diff: 336,
              interpolated: false,
            },
            {
              value: 237634,
              timestp: "2023-05-26T00:00:00.000Z",
              daily_diff: 300,
              interpolated: false,
            },
            {
              value: 237946,
              timestp: "2023-05-27T00:00:00.000Z",
              daily_diff: 312,
              interpolated: false,
            },
            {
              value: 238245,
              timestp: "2023-05-28T00:00:00.000Z",
              daily_diff: 299,
              interpolated: false,
            },
            {
              value: 238580,
              timestp: "2023-05-29T00:00:00.000Z",
              daily_diff: 335,
              interpolated: false,
            },
            {
              value: 238885,
              timestp: "2023-05-30T00:00:00.000Z",
              daily_diff: 305,
              interpolated: false,
            },
            {
              value: 239181,
              timestp: "2023-05-31T00:00:00.000Z",
              daily_diff: 296,
              interpolated: false,
            },
            {
              value: 239396,
              timestp: "2023-06-01T00:00:00.000Z",
              daily_diff: 215,
              interpolated: false,
            },
            {
              value: 239643,
              timestp: "2023-06-02T00:00:00.000Z",
              daily_diff: 247,
              interpolated: false,
            },
            {
              value: 239902,
              timestp: "2023-06-03T00:00:00.000Z",
              daily_diff: 259,
              interpolated: false,
            },
            {
              value: 240185,
              timestp: "2023-06-04T00:00:00.000Z",
              daily_diff: 283,
              interpolated: false,
            },
            {
              value: 240496,
              timestp: "2023-06-05T00:00:00.000Z",
              daily_diff: 311,
              interpolated: false,
            },
            {
              value: 240731,
              timestp: "2023-06-06T00:00:00.000Z",
              daily_diff: 235,
              interpolated: false,
            },
            {
              value: 241015,
              timestp: "2023-06-07T00:00:00.000Z",
              daily_diff: 284,
              interpolated: false,
            },
          ],
        },
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 801,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1155729,
              },
              likes: {
                title: "Likes",
                value: 81640360,
              },
              views: {
                title: "Views",
                value: 684260038,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 534617145,
              },
              trackStations: {
                title: "Track Stations",
                value: 468692,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 86,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 73005412,
              },
              streams: {
                title: "Streams",
                value: 1884477857,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1155441043,
              },
              likes: {
                title: "Likes",
                value: 10683976,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 11441797,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 7153351,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 619067,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 19289,
              },
              count: {
                title: "Listen Count",
                value: 3014040,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 44090,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 58221,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://www.nme.com/news/music/lizzo-latto-loyle-carner-and-100-new-names-complete-roskilde-2023-line-up-3424500?utm_source=rss&utm_medium=rss&utm_campaign=lizzo-latto-loyle-carner-and-100-new-names-complete-roskilde-2023-line-up",
        title:
          "Lizzo, Latto, Loyle Carner and 100 new names complete Roskilde 2023 line-up",
        source: "New Musical Express",
        image_url:
          "https://www.nme.com/wp-content/uploads/2019/11/logo-nme.svg",
        date: "2023-04-01T13:49:55.000Z",
      },
      {
        url: "https://www.complex.com/music/young-guru-concerned-over-jay-z-ai-verse",
        title: "Young Guru Shares Concern Over AI-Generated Jay-Z Verse",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-31T21:48:52.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/power-of-women-2023-music-executives-impact-1235569511/",
        title:
          "Power of Women 2023: The NY-Based Female Music Executives Making an Impact",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-31T00:12:13.000Z",
      },
      {
        url: "https://fomoblog.com/2023/03/30/how-the-high-art-of-drakes-hotline-bling-music-video-inspired-director-x-to-create-new-video-star-docuseries/",
        title:
          "How the High Art of Drake’s ‘Hotline Bling’ Music Video Inspired Director X to Create New ‘Video Star’ Docuseries",
        source: "FOMOBLOG",
        image_url:
          "https://fomoblog.com/wp-content/uploads/2018/04/fomoblog_logo_lowercase_2.png",
        date: "2023-03-30T22:13:37.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/director-x-video-star-music-videos-interview-1235568666/",
        title:
          "How the High Art of Drake’s ‘Hotline Bling’ Music Video Inspired Director X to Create New ‘Video Star’ Docuseries",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-30T19:51:28.000Z",
      },
      {
        url: "https://www.thelineofbestfit.com/news/lizzo-ethel-cain-loyle-carner-and-more-complete-roskilde-2023-line-up",
        title:
          "Lizzo, Ethel Cain, Loyle Carner and more complete Roskilde 2023 line-up",
        source: "The Line of Best Fit",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/The_Line_Of_Best_Fit.svg/250px-The_Line_Of_Best_Fit.svg.png",
        date: "2023-03-30T15:00:00.000Z",
      },
      {
        url: "https://www.npr.org/2023/03/30/1166299611/doechii-youtube-nudity-body-policing",
        title: "'I'm coming to y'all with no armor'",
        source: "National Public Radio",
        image_url: "https://media.npr.org/chrome_svg/npr-logo.svg",
        date: "2023-03-30T09:00:09.000Z",
      },
      {
        url: "https://www.complex.com/music/mapping-j-cole-and-drakes-careers-together",
        title:
          "Drake and J. Cole Walked Parallel Paths on the Way to Running Rap",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-29T18:01:08.000Z",
      },
    ],
    artist: {
      id: 3768,
      name: "Kendrick Lamar",
      biography: `Indisputably the most acclaimed rap artist of his generation, Kendrick Lamar is one of those rare MCs who has achieved critical and commercial success while earning the respect and support of those who inspired him. After several years of development, Lamar hit his creative and chart-topping stride in the 2010s. Good Kid, M.A.A.D City (2012), the Grammy-winning To Pimp a Butterfly (2015), and the Grammy- and Pulitzer Prize-winning DAMN. (2017), his three proper major-label albums, have displayed an unmatched mix of inventive wordplay and compelling conceptual narratives, examining internal conflict, flaunting success, and uplifting his community. The screenplay-level detail of Lamar's writing has been enriched by a collective of producers, instrumentalists, singers, and rappers, a high percentage of whom -- including inspirations Dr. Dre and MC Eiht , and contemporaries Sounwave and Jay Rock -- represent Lamar's native Los Angeles. Lamar's cinematic and collaborative inclinations inevitably attracted the mainstream film industry. Black Panther: The Album (2018) was the source of three of Lamar's Top Ten pop hits. In 2022 he delivered Mr. Morale & the Big Steppers, his fifth studio album and what would be his last with Top Dawg Entertainment .`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Growth",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 24121098,
              rank: 54,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 50358060,
              rank: 41,
            },
            popularity: {
              title: "Popularity",
              value: 89,
              rank: 23,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 481491077,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "47.9%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "19.96x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 12579097,
              rank: 538,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            topVideoViews: {
              title: "Top Video Views",
              value: 8800847645,
              rank: 189,
            },
            postCount: {
              title: "Post Count",
              value: 7777943,
              rank: 198,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 12000000,
              rank: 283,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 5678763832,
              rank: 280,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 4076847,
              rank: 152,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 112361491,
              rank: 174,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2937009,
              rank: 174,
            },
            streams: {
              title: "Streams",
              value: 6121084101,
              rank: 51,
            },
            artistStations: {
              title: "Artist Stations",
              value: 26390530,
              rank: 25,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 4988691,
              rank: 75,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 130946311,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 14432,
              rank: 683,
            },
            likes: {
              title: "Likes",
              value: 52179,
              rank: 646,
            },
            plays: {
              title: "Plays",
              value: 8191267,
              rank: 511,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1136,
              rank: 686,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 34069,
              rank: 168,
            },
            likes: {
              title: "Likes",
              value: 190129,
              rank: 246,
            },
            videoLikes: {
              title: "Video Likes",
              value: 1156,
              rank: 270,
            },
            videoViews: {
              title: "Video Views",
              value: 187089,
              rank: 234,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 206314065,
            },
          },
        },
      },
    },
  },
  {
    auctionID: 9357,
    symbolID: "TOP_2000",
    symbolType: "Catalog",
    title: "ALL out 2000s",
    genre: ["Mix"],
    description: `The mix catalog of songs comprising "Yellow" by Coldplay, "Without Me" by Halsey, "In the End" by Linkin Park, "Mr. Brightside" by The Killers, "Heartless" by Kanye West,
    "Hips Don't Lie" featuring Wyclef Jean by Shakira, "Seven Nation Army" by The White Stripes, "Viva La Vida" by Coldplay, "The Real Slim Shady" by Eminem, "Numb" by
    Linkin Park, "Feel Good Inc." by Gorillaz, and "Flashing Lights" by Kanye West not only showcases an eclectic mix of genres and artists but also represents a testament to
    their enduring popularity and the steady growth patterns they have exhibited over the last 19 years.`,
    startDate: "06/05/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 100,
    minAuctionTarget: 1482485,
    minOrder: 50,
    currentPrice: "$9.56",
    priceIncrease: "$0.19",
    targetPricePerUnit: "$12.65",
    averageYield: "5.1%",
    LTMYield: "6.0%",
    lastPrice: "$9.56",
    weeklyVolume: "127",
    change: "1.21%",
    dalyGain: "$2.35",
    totalGain: "$5.3",
    royalties: "$127",
    aveCost: "$1.12",
    orderType: "Buy",
    bidPerUnit: "7.25",
    bidUnits: "42",
    askPerUnit: "7.56",
    askUnits: "12.39",
    spotifyLink: "https://open.spotify.com/playlist/37i9dQZF1DX4o1oenSJRJd",
    imgSrc: ["auctions/all-out-2000s.jfif"],
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$14,510",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$20,817",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Sales , Sync",
      },
      {
        title: "Distributors",
        description: "ASCAP/ BMI",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Catalog",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "12",
      },
      {
        title: "Record lable",
        description: "Multiple",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/YVkUvmDQ3HY",
        thumbnail: "tracks/yellow-video.png",
      },
      {
        link: "https://www.youtube.com/embed/eVTXPUF4Oz4",
        thumbnail: "tracks/without-me-video.png",
      },
      {
        link: "https://www.youtube.com/embed/gGdGFtwCNBE",
        thumbnail: "tracks/in-the-end-video.png",
      },
      {
        link: "https://www.youtube.com/embed/Co0tTeuUVhU",
        thumbnail: "tracks/yellow-video.png",
      },
      {
        link: "https://www.youtube.com/embed/DUT5rEU6pqM",
        thumbnail: "auctions/the-street-band.jpg",
      },
      {
        link: "https://www.youtube.com/embed/0J2QdDbelmY",
        thumbnail: "auctions/the-street-band.jpg",
      },
    ],
    tracks: [
      {
        id: "12521939",
        isrc: "GBAYE0000267",
        title: "Yellow",
        artist: "Coldplay",
        album: "Now (That's What I Call Music) Vol. 6",
        releaseDate: "01/01/1999",
        imgSrc: "auctions/the-street-band-3.jpg",
        spotifyLink: "https://open.spotify.com/track/3AJwUDP919kvQ9QcozQPxg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 182,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1837717,
              },
              likes: {
                title: "Likes",
                value: 557700738,
              },
              views: {
                title: "Views",
                value: 4011733883,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 72,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 153164790,
              },
              streams: {
                title: "Streams",
                value: 1660569609,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 261405758,
              },
              likes: {
                title: "Likes",
                value: 2280842,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4840523,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 3031,
              },
              count: {
                title: "Listen Count",
                value: 401756,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 41359,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 76068,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 72,
              },
            },
          },
        },
      },
      {
        id: "15414251",
        isrc: "USIR10211038",
        title: "Without Me",
        artist: "Eminem",
        album: "The Source - Hip Hop Hits Vol. 6",
        releaseDate: "01/01/2002",
        spotifyLink: "https://open.spotify.com/track/7lQ8MOhq6IN2w8EYcFNSUk",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 330,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 760075,
              },
              likes: {
                title: "Likes",
                value: 26613301,
              },
              views: {
                title: "Views",
                value: 169701540,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 29819812,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 345119603,
              },
              trackStations: {
                title: "Track Stations",
                value: 181540,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 90,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 69666434,
              },
              streams: {
                title: "Streams",
                value: 1618660529,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 253788281,
              },
              likes: {
                title: "Likes",
                value: 2602019,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3669803,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 10519870,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 922419,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 23840,
              },
              count: {
                title: "Listen Count",
                value: 2282556,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 32219,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 26199,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 79,
              },
            },
          },
        },
      },
      {
        id: "16010790",
        isrc: "USWB10002407",
        title: "In the End",
        artist: "Linkin Park",
        album: "Hybrid Theory (Bonus Track Version)",
        releaseDate: "10/24/2000",
        spotifyLink: "https://open.spotify.com/track/60a0Rd6pjrkxjPbaKzXjfq",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 210,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 399812,
              },
              likes: {
                title: "Likes",
                value: 49990312,
              },
              views: {
                title: "Views",
                value: 558897298,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 26291074,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 88,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 79150026,
              },
              streams: {
                title: "Streams",
                value: 1570623945,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 2035883007,
              },
              likes: {
                title: "Likes",
                value: 15824027,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 2099167,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 25031,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2764583,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 5219,
              },
              count: {
                title: "Listen Count",
                value: 617281,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 12519,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 165241,
              },
            },
          },
        },
      },
      {
        id: "15419058",
        isrc: "USIR20400274",
        title: "Mr. Brightside",
        artist: "The Killers",
        album: "Hot Fuss",
        releaseDate: "01/01/2004",
        spotifyLink: "https://open.spotify.com/track/003vvx7Niy0yvhvHt4a68B",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 287,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 93228,
              },
              likes: {
                title: "Likes",
                value: 39772162,
              },
              views: {
                title: "Views",
                value: 278621708,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 2610968,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 752966228,
              },
              trackStations: {
                title: "Track Stations",
                value: 339730,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 134255792,
              },
              streams: {
                title: "Streams",
                value: 1757100670,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 136268788,
              },
              likes: {
                title: "Likes",
                value: 1415769,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3494539,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 7413136,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2886102,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 186168,
              },
            },
          },
        },
      },
      {
        id: "15911299",
        isrc: "USUM70840511",
        title: "Heartless",
        artist: "Kanye West",
        album: "808s & Heartbreak (Exclusive Edition)",
        releaseDate: "01/01/2008",
        spotifyLink: "https://open.spotify.com/track/4EWCNWgDS8707fNSZ1oaA5",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 289,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 123878,
              },
              likes: {
                title: "Likes",
                value: 27481402,
              },
              views: {
                title: "Views",
                value: 213826453,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 46305318,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 564229863,
              },
              trackStations: {
                title: "Track Stations",
                value: 407093,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 45292740,
              },
              streams: {
                title: "Streams",
                value: 836046887,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 315234433,
              },
              likes: {
                title: "Likes",
                value: 2327031,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 1306909,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 3288014,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 185027,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 674,
              },
              count: {
                title: "Listen Count",
                value: 77490,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 14973,
              },
            },
          },
        },
      },
      {
        id: "15778873",
        isrc: "USSM10600677",
        title: "Hips Don't Lie (feat. Wyclef Jean)",
        artist: "Shakira, Wyclef Jean",
        album: "Fijacion Oral/Oral Fixation Vol. 2",
        releaseDate: "01/01/2005",
        spotifyLink: "https://open.spotify.com/track/3ZFTkvIE7kyPt6Nu3PEa7V",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 271,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 2543977,
              },
              likes: {
                title: "Likes",
                value: 257601371,
              },
              views: {
                title: "Views",
                value: 2176769848,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 1559867,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 369454015,
              },
              trackStations: {
                title: "Track Stations",
                value: 336499,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 111839990,
              },
              streams: {
                title: "Streams",
                value: 1269316710,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1475008904,
              },
              likes: {
                title: "Likes",
                value: 8372408,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 5547340,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2870516,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 581,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 180934,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 70,
              },
            },
          },
        },
      },
      {
        id: "16007454",
        isrc: "USVT10300001",
        title: "Seven Nation Army",
        artist: "The White Stripes",
        album: "Elephant",
        releaseDate: "01/01/2003",
        spotifyLink: "https://open.spotify.com/track/3dPQuX8Gs42Y7b454ybpMR",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 350,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 256181,
              },
              likes: {
                title: "Likes",
                value: 131457369,
              },
              views: {
                title: "Views",
                value: 1302941438,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 874077205,
              },
              trackStations: {
                title: "Track Stations",
                value: 543673,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 86,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 100091983,
              },
              streams: {
                title: "Streams",
                value: 1313133074,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 243565069,
              },
              likes: {
                title: "Likes",
                value: 3277371,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 8755872,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 1072275,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 176357,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 16,
              },
            },
          },
        },
      },
      {
        id: "12526559",
        isrc: "GBAYE0800265",
        title: "Viva La Vida",
        artist: "Coldplay",
        album: "DDB Hitzone Best Of 2008",
        releaseDate: "01/01/2008",
        spotifyLink: "https://open.spotify.com/track/1mea3bSkSGXuIRvnydlB5b",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 264,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 888472,
              },
              likes: {
                title: "Likes",
                value: 175331132,
              },
              views: {
                title: "Views",
                value: 1560456627,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 1589137,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 89,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 100069055,
              },
              streams: {
                title: "Streams",
                value: 1503337703,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1218159627,
              },
              likes: {
                title: "Likes",
                value: 7593404,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3314668,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 46681,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 1598401,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 32183,
              },
              count: {
                title: "Listen Count",
                value: 4046114,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 134606,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 292726,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 71,
              },
            },
          },
        },
      },
      {
        id: "15413181",
        isrc: "USIR10000448",
        title: "The Real Slim Shady",
        artist: "Eminem",
        album: "The Source Hip-Hop Hits Vol. 4",
        releaseDate: "01/01/2000",
        spotifyLink: "https://open.spotify.com/track/3yfqSUWxFvZELEM4PmlwIR",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 276,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 56493,
              },
              likes: {
                title: "Likes",
                value: 61537777,
              },
              views: {
                title: "Views",
                value: 494426407,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 916004,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 417043762,
              },
              trackStations: {
                title: "Track Stations",
                value: 1176728,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 89,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 62845180,
              },
              streams: {
                title: "Streams",
                value: 1373725489,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1023659704,
              },
              likes: {
                title: "Likes",
                value: 9043090,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3483932,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 5749099,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 674062,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 9880,
              },
              count: {
                title: "Listen Count",
                value: 793636,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 63498,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 79,
              },
            },
          },
        },
      },
      {
        id: "100922394",
        isrc: "USWB11201339",
        title: "Numb",
        artist: "Linkin Park",
        album: "Meteora 20th Anniversary Edition",
        releaseDate: "04/07/2023",
        spotifyLink: "https://open.spotify.com/track/2nLtzopw4rPReszdYBJU6h",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 3222,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 1934456,
              },
              streams: {
                title: "Streams",
                value: 1310965246,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 253788281,
              },
              likes: {
                title: "Likes",
                value: 2602019,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 245,
              },
            },
          },
        },
      },
      {
        id: "12524549",
        isrc: "GBAYE0500172",
        title: "Feel Good Inc.",
        artist: "Gorillaz",
        album: "Demon Days",
        releaseDate: "05/23/2005",
        spotifyLink: "https://open.spotify.com/track/0d28khcov6AiegSCpG5TuT",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 171,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 313795,
              },
              likes: {
                title: "Likes",
                value: 131009785,
              },
              views: {
                title: "Views",
                value: 1165950608,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 85,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 62951631,
              },
              streams: {
                title: "Streams",
                value: 1123365929,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1007771006,
              },
              likes: {
                title: "Likes",
                value: 9500518,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 7340,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 3205329,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 3591,
              },
              count: {
                title: "Listen Count",
                value: 341522,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 134067,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 79,
              },
            },
          },
        },
      },
      {
        id: "15907088",
        isrc: "USUM70749095",
        title: "Flashing Lights",
        artist: "Kanye West,Dwele",
        album: "Graduation",
        releaseDate: "09/11/2007",
        spotifyLink: "https://open.spotify.com/track/5TRPicyLGbAF2LGBFbHGvO",
        imgSrc: "auctions/the-street-band-3.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 117,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 267604,
              },
              likes: {
                title: "Likes",
                value: 100230278,
              },
              views: {
                title: "Views",
                value: 759243303,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 11557614,
              },
              trackStations: {
                title: "Track Stations",
                value: 6236,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 86,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 33893789,
              },
              streams: {
                title: "Streams",
                value: 636850360,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 215464990,
              },
              likes: {
                title: "Likes",
                value: 1847346,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 1220438,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 3642598,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 55483,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 16976,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://www.nme.com/news/music/lizzo-latto-loyle-carner-and-100-new-names-complete-roskilde-2023-line-up-3424500?utm_source=rss&utm_medium=rss&utm_campaign=lizzo-latto-loyle-carner-and-100-new-names-complete-roskilde-2023-line-up",
        title:
          "Lizzo, Latto, Loyle Carner and 100 new names complete Roskilde 2023 line-up",
        source: "New Musical Express",
        image_url:
          "https://www.nme.com/wp-content/uploads/2019/11/logo-nme.svg",
        date: "2023-04-01T13:49:55.000Z",
      },
      {
        url: "https://www.complex.com/music/young-guru-concerned-over-jay-z-ai-verse",
        title: "Young Guru Shares Concern Over AI-Generated Jay-Z Verse",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-31T21:48:52.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/power-of-women-2023-music-executives-impact-1235569511/",
        title:
          "Power of Women 2023: The NY-Based Female Music Executives Making an Impact",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-31T00:12:13.000Z",
      },
      {
        url: "https://fomoblog.com/2023/03/30/how-the-high-art-of-drakes-hotline-bling-music-video-inspired-director-x-to-create-new-video-star-docuseries/",
        title:
          "How the High Art of Drake’s ‘Hotline Bling’ Music Video Inspired Director X to Create New ‘Video Star’ Docuseries",
        source: "FOMOBLOG",
        image_url:
          "https://fomoblog.com/wp-content/uploads/2018/04/fomoblog_logo_lowercase_2.png",
        date: "2023-03-30T22:13:37.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/director-x-video-star-music-videos-interview-1235568666/",
        title:
          "How the High Art of Drake’s ‘Hotline Bling’ Music Video Inspired Director X to Create New ‘Video Star’ Docuseries",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-30T19:51:28.000Z",
      },
      {
        url: "https://www.thelineofbestfit.com/news/lizzo-ethel-cain-loyle-carner-and-more-complete-roskilde-2023-line-up",
        title:
          "Lizzo, Ethel Cain, Loyle Carner and more complete Roskilde 2023 line-up",
        source: "The Line of Best Fit",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/The_Line_Of_Best_Fit.svg/250px-The_Line_Of_Best_Fit.svg.png",
        date: "2023-03-30T15:00:00.000Z",
      },
      {
        url: "https://www.npr.org/2023/03/30/1166299611/doechii-youtube-nudity-body-policing",
        title: "'I'm coming to y'all with no armor'",
        source: "National Public Radio",
        image_url: "https://media.npr.org/chrome_svg/npr-logo.svg",
        date: "2023-03-30T09:00:09.000Z",
      },
      {
        url: "https://www.complex.com/music/mapping-j-cole-and-drakes-careers-together",
        title:
          "Drake and J. Cole Walked Parallel Paths on the Way to Running Rap",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-29T18:01:08.000Z",
      },
      {
        url: "https://www.complex.com/music/tyler-the-creator-sorry-not-sorry-video",
        title:
          "Tyler, the Creator Continues ‘Call Me If You Get Lost: The Estate Sale’ Rollout With “Sorry Not Sorry” Video",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-29T14:08:01.000Z",
      },
      {
        url: "https://www.digitalmusicnews.com/2023/03/28/life-is-beautiful-2023-lineup/",
        title:
          "Life is Beautiful 2023 Celebrates 10th Anniversary With The Killers, Kendrick Lamar, Odesza, Nelly, and Many More",
        source: "Digital Music News",
        image_url:
          "https://www.digitalmusicnews.com/wp-content/uploads/2016/01/DMN_Logo_340-1.png",
        date: "2023-03-29T04:58:18.000Z",
      },
    ],
    artist: {
      name: "2000 Top USA MIX",
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 19000000000,
              rank: 41,
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7100000,
              rank: 538,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 7000000000,
              rank: 174,
            },
          },
        },
      },
    },
  },

  {
    auctionID: 3568,
    ch_albumID: 3118249,
    symbolID: "AL-TD",
    title: "Nevermind",
    artist: "Nirvana",
    artistBio: `It must have been a rude surprise for <a href=\"spotify:artist:6pAuTi6FXi6qFQJ1dzMXQs\">Kurt Cobain</a> and company to be hit with a 
    lawsuit over the name of their band once they became internationally successful. In the finish, however, the result was relatively amicable, with 
    the original <a href=\"spotify:artist:6olE6TJLqED3rqDCT0FyPh\">Nirvana</a> getting together long enough to record a version of <a href=\"spotify:
    artist:6pAuTi6FXi6qFQJ1dzMXQs\">Cobain</a>'s \"Lithium\" for a 1996 collectionof previously unreleased material. 
    \r\n\n<a href=\"spotify:artist:6olE6TJLqED3rqDCT0FyPh\">Nirvana</a> appeared in 1967, starting as a six-piece led by 
    <a href=\"spotify:artist:41906y9lkZkZNmpEDbxNmM\">Patrick Campbell-Lyons</a> from Ireland, and Alex Spyropoulos from Greece. They were quickly signed 
    to the fledgling Island label, whichhad formed out of Chris Blackwell's street-level R&B and rocksteady label operations, when Blackwell recognized 
    a need to hook into the exploding psychedelic genre of the time. The first LP to emerge was the science-fiction concept album, The Story of Simon Simopath,
    which yielded their second single, \"Pentecost Hotel\" (their first and third singles appeared on the follow-up, All of Us.)\r\n\nThe band's early 
    performances yielded something of an audience, but this did not translate into explosive sales in England or America, though the band achieved some 
    success in Europe. Winnowing down to the core duo of <a href=\"spotify:artist:41906y9lkZkZNmpEDbxNmM\">Campbell-Lyons</a> and Spyropoulos, 
    <a href=\"spotify:artist:6olE6TJLqED3rqDCT0FyPh\">Nirvana</a> continued to release singles from All of Us, with the title track going on to be 
    selected as the theme song for The Touchables, while \"Rainbow Chaser,\" an almost-hit, came to be considered a classic psychedelic outing.
    \r\n\nLife at Island Records did not go so well, unfortunately, with Chris Blackwell refusing to release their third album, Black Flower, so the duo
    picked up and moved on to Pye Records, home of <a href=\"spotify:artist:1SQRv42e4PjEYfPhS0Tk9E\">the Kinks</a>. Black Flower was bought back 
    from Island and worked over, finally being released as Dedicated to Markos III. The result was disastrous. The constantly beleaguered Pye (which would 
      eventually founder) managed to shift only a few hundred units, while the U.S. label to which the album was licensed promptly went under with no more 
      than a few promotional copies having been sent out. Dedicated to Markos III eventually received another release in 1987, restored to the original 
      title of Black Flower, with the 1993 Edsel CD release including a re-recorded version of \"Pentecost Hotel\" and a newly recorded track titled \"Shine.\"
      \r\n\nWith the release of Dedicated to Markos III, Spyropoulos quit to pursue other musical work. <a href=\"spotify:artist:6olE6TJLqED3rqDCT0FyPh\">Nirvana</a>
      had become very much <a href=\"spotify:artist:41906y9lkZkZNmpEDbxNmM\">Campbell-Lyons</a>' venue by this point, and Spyropoulos had had enough of 
      feeling constrained. <a href=\"spotify:artist:41906y9lkZkZNmpEDbxNmM\">Campbell-Lyons</a> then signed to Philips' new progressive label, Vertigo, 
      recording and releasing Local Anaesthetic, a heavily jazz-influenced album featuring only two cuts: \"Modus Operandi,\" and the somewhat less epic \"Home.\"
      The album was quick to disappear from view, as was Songs of Love and Praise, which featured several re-recorded cuts, including both \"Rainbow Chaser\" 
      and \"Pentecost Hotel.\" \r\n\n<a href=\"spotify:artist:41906y9lkZkZNmpEDbxNmM\">Campbell-Lyons</a> came out from behind the
      <a href=\"spotify:artist:6olE6TJLqED3rqDCT0FyPh\">Nirvana</a> name for an attempt at a solo album,
      Me & My Friend, which came and went swiftly in 1973. In 1980, he reunited with Spyropoulos to write a musical, Blood, which has yet to surface. The 
      duo have sporadically performed and recorded as <a href=\"spotify:artist:6olE6TJLqED3rqDCT0FyPh\">Nirvana</a>, which led to Bam Caruso's 1987 reissue 
      of Black Flower, as well as renewed interest in the group. Most of the original albums have been reissued by either Edsel or Repertoire (Songs of Love 
        and Praise is the sole exception), a collection of demos and outtakes, entitled Secret Theatre, has been released, and a new album, Orange and Blue, 
        featuring material previously unrecorded by the band, was issued in 1996. \r\n\nFrom all indications, it would appear that 
        <a href=\"spotify:artist:6olE6TJLqED3rqDCT0FyPh\">Nirvana</a>, having come together again in the '90s, intends to be around for some time longer. ~ 
        Steven McDonald, Rovi`,

    ch_artistID: 19,
    description: `The discography of Nirvana, an American Rock band, consist of three studio albums, twenty-one singles, five live albums,
                        two extended plays, four compilation albums, and two box sets.<br/><br/>Nirvana was formed in 1987 by vocalist and guitarist 
                        Kurt Cobain and bassit Krist Novoselic, with the position of drummer being filled by various musicians. The band released
                        its debut album, Bleach, in 1989 on independent label Sub Pop. After being joined by final drummer Dave Grohl and signing
                        to Geffen Records subsidiary DGC Records, the band released its second studio album, Nevermind, which became one of the
                        best selling alternative albums.`,

    genre: ["Rock", "American"],
    startDate: "04/05/2023 00:00:00",
    endDate: "03/10/2023 22:00:00",
    units: 3000,
    minAuctionTarget: 1482485,
    minOrder: 50,
    currentPrice: "$9.56",
    priceIncrease: "$0.19",
    targetPricePerUnit: "$12.65",
    averageYield: "5.1%",
    LTMYield: "6.0%",
    lastPrice: "$3.39",
    weeklyVolume: "45",
    change: "1.21%",
    dalyGain: "$2.35",
    totalGain: "$5.3",
    royalties: "$127",
    aveCost: "$1.12",
    orderType: "Buy",
    bidPerUnit: "7.25",
    bidUnits: "42",
    askPerUnit: "$54,000",
    askUnits: "12.39",
    offlineUnits: "3,000",
    unitsValue: "$54,000",
    spotifyLink: "https://open.spotify.com/album/2UJcKiJxNryhL050F5Z1Fk",
    imgSrc: ["auctions/nevermind.jpg"],
    metrics: {
      spotify: 174480,
      instagram: 5640,
    },
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$14,510",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$20,817",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "BMI, ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/7TDeBi34OtE",
        thumbnail: "auctions/nevermind.jpg",
      },
      {
        link: "https://www.youtube.com/embed/naW6-WxmMiU",
        thumbnail: "auctions/nevermind.jpg",
      },
      {
        link: "https://www.youtube.com/embed/pkcJEvMcnEg",
        thumbnail: "auctions/nevermind.jpg",
      },
      {
        link: "https://www.youtube.com/embed/Ee6xkwVucIE",
        thumbnail: "auctions/nevermind.jpg",
      },
      {
        link: "https://www.youtube.com/embed/vabnZ9-ex7o",
        thumbnail: "auctions/nevermind.jpg",
      },
    ],
    tracks: [
      {
        id: "41226160",
        title: "Smells Like Teen Spirit",
        artist: "Nirvana",
        album: "Nevermind",
        releaseDate: "12/12/1998",
        imgSrc: "auctions/smells-like-teen-spirit.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 194,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 182686,
              },
              likes: {
                title: "Likes",
                value: 83241314,
              },
              views: {
                title: "Views",
                value: 588461788,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 8344041,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 403336924,
              },
              trackStations: {
                title: "Track Stations",
                value: 284059,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 84,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 103517397,
              },
              streams: {
                title: "Streams",
                value: 1637259004,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 277074732,
              },
              likes: {
                title: "Likes",
                value: 4492107,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 2708308,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 10759042,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4402087,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 22088,
              },
              listenCount: {
                title: "Listen Count",
                value: 2773610,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.jpg",
            statistics: {
              likes: {
                title: "Likes",
                value: 28170,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 168415,
              },
            },
          },
        },
      },
      {
        id: "19721875",
        title: "In Bloom",
        artist: "Nirvana",
        album: "Nevermind",
        releaseDate: "12/12/1998",
        imgSrc: "auctions/in-bloom.jpg",
      },
      {
        id: "42031249",
        title: "Come as you are",
        artist: "Nirvana",
        album: "Nevermind",
        releaseDate: "12/12/1998",
        imgSrc: "auctions/come-as-you-are.jpg",
      },
      {
        id: "42031247",
        title: `Breed`,
        artist: "Nirvana",
        album: "Nevermind",
        releaseDate: "12/12/1998",
        imgSrc: "auctions/breed.jpg",
      },
      {
        id: "42031248",
        title: "Lithium",
        artist: "Nirvana",
        album: "Nevermind",
        releaseDate: "12/12/1998",
        imgSrc: "auctions/lithium.jpg",
      },
    ],
    mentions: [
      {
        url: "https://variety.com/2023/music/news/atlantic-tag-gabe-saporta-sophie-powers-jules-is-dead-1235568627/",
        title:
          "Atlantic Launches Joint Venture With Cobra Starship Alum Gabe Saporta, TAG Music (EXCLUSIVE)",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-30T16:11:38.000Z",
      },
      {
        url: "https://www.brooklynvegan.com/deerhoofs-greg-saunier-discusses-the-influences-behind-the-bands-new-lp-miracle-level/",
        title:
          "Deerhoof’s Greg Saunier discusses the influences behind the band’s new LP ‘Miracle-Level’",
        source: "Brooklyn Vegan",
        image_url:
          "https://townsquare.media/site/838/files/2017/10/bv-1logo-new1.png",
        date: "2023-03-30T15:24:09.000Z",
      },
      {
        url: "https://thegroovecartel.com/news/rufus-du-sol-cover-nirvana-something-in-the-way/",
        title:
          "Rüfüs Du Sol Release Cover of Nirvana Classic ‘Something in the Way’",
        source: "Groove Cartel ",
        image_url:
          "https://thegroovecartel.com/wp-content/uploads/2016/03/mobile.png",
        date: "2023-03-24T22:55:03.000Z",
      },
      {
        url: "https://www.nytimes.com/2023/03/19/arts/music/depeche-mode-memento-mori.html",
        title: "The Exquisite Darkness of Depeche Mode",
        source: "New York Times",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/NewYorkTimes.svg/250px-NewYorkTimes.svg.png",
        date: "2023-03-19T18:00:05.000Z",
      },
      {
        url: "https://www.metalsucks.net/2023/03/18/courtney-love-thinks-the-rock-and-roll-hall-of-fame-needs-more-women/",
        title:
          "Courtney Love Thinks The Rock And Roll Hall of Fame Needs More Women",
        source: "Metal Sucks",
        image_url:
          "https://storage.googleapis.com/cm-app-assets/logos/logo-metalsucks.svg",
        date: "2023-03-18T18:15:45.000Z",
      },
      {
        url: "https://louderthanwar.com/the-strangerz-hit-the-ground-single-review/",
        title: "The Strangerz: Hit The Ground – Single Review",
        source: "Louder Than War",
        image_url:
          "https://louderthanwar.com/wp-content/uploads/2019/08/louder-than-war-logo.png",
        date: "2023-03-18T12:22:03.000Z",
      },
      {
        url: "https://variety.com/2023/music/news/courtney-love-rock-hall-fame-hole-1235557834/",
        title:
          "Courtney Love Slams Rock & Roll Hall of Fame for Lack of Female Inductees: It ‘Reeks of Sexist Gatekeeping’",
        source: "Variety",
        image_url:
          "https://upload.wikimedia.org/wikipedia/en/thumb/f/f4/Variety_2013_logo.svg/180px-Variety_2013_logo.svg.png",
        date: "2023-03-17T21:28:19.000Z",
      },
      {
        url: "https://pitchfork.com/news/courtney-love-criticizes-rock-hall-sexist-gatekeeping-in-guardian-op-ed",
        title:
          "Courtney Love Criticizes Rock Hall’s “Sexist Gatekeeping” in Guardian Op-Ed",
        source: "Pitchfork",
        image_url:
          "https://storage.googleapis.com/cm-app-assets/logos/logo-pitchfork.svg",
        date: "2023-03-17T18:38:42.000Z",
      },
      {
        url: "https://www.rollingstone.com/music/music-news/courtney-love-rock-hall-sexist-gatekeeping-kate-bush-chaka-khan-op-ed-1234699138/",
        title:
          "Courtney Love Slams Rock Hall’s ‘Sexist Gatekeeping’ in Scathing Op-Ed",
        source: "Rolling Stone",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Rolling_Stone_2019.svg/180px-Rolling_Stone_2019.svg.png",
        date: "2023-03-17T18:22:21.000Z",
      },
      {
        url: "https://www.altpress.com/kurt-cobain-dress-nirvana-dive-watch/",
        title:
          "Flashback: See Nirvana's Kurt Cobain wear a dress onstage in 1993",
        source: "Alternative Press",
        image_url:
          "https://media.altpress.com/uploads/2021/03/AP-LOGO-PHOTOCOPY_RED-1.png",
        date: "2023-03-17T15:00:04.000Z",
      },
    ],
    socialMediaStatistics: {
      spotify: {
        socialMedia: "Spotify",
        icon: "social-media-logos/spotify.png",
        statistics: {
          followers: {
            title: "Followers",
            value: 17621965,
            rank: 87,
          },
          monthlyListeners: {
            title: "Monthly Listeners",
            value: 28111911,
            rank: 141,
          },
          popularity: {
            title: "Popularity",
            value: 81,
            rank: 179,
          },
          playlistReach: {
            title: "Playlist Reach",
            value: 163309333,
          },
          fanConversionRate: {
            title: "Fan Conversion Rate",
            value: "106.75%",
          },
          reachFollowersRatio: {
            title: "Reach / Followers Ratio",
            value: "5.25x",
          },
        },
      },
      instagram: {
        socialMedia: "Instagram",
        icon: "social-media-logos/instagram.png",
        statistics: {
          followers: {
            title: "Followers",
            value: 87889,
            rank: 30979,
          },
        },
      },
      tiktok: {
        socialMedia: "TikTok",
        icon: "social-media-logos/tiktok.png",
        statistics: {
          topVideoViews: {
            title: "Top Video Views",
            value: 2892958116,
            rank: 833,
          },
          postCount: {
            title: "Post Count",
            value: 696559,
            rank: 2941,
          },
        },
      },
      youtube: {
        socialMedia: "YouTube",
        icon: "social-media-logos/youtube.png",
        statistics: {
          channelSubscribers: {
            title: "Channel Subscribers",
            value: 8740000,
            rank: 449,
          },
          channelViews: {
            title: "Channel Views",
            value: 5540634299,
            rank: 289,
          },
          dailyVideoViews: {
            title: "Daily Video Views",
            value: 3107714,
            rank: 288,
          },
          monthlyVideoViews: {
            title: "Monthly Video Views",
            value: 78192412,
            rank: 295,
          },
        },
      },
      pandora: {
        socialMedia: "Pandora",
        icon: "social-media-logos/pandora.png",
        statistics: {
          monthlyListeners: {
            title: "Monthly Listeners",
            value: 2661262,
            rank: 218,
          },
          streams: {
            title: "Streams",
            value: 3492415525,
            rank: 163,
          },
          artistStations: {
            title: "Artist Stations",
            value: "55.1M",
            rank: "3",
          },
        },
      },
      deezer: {
        socialMedia: "Deezer",
        icon: "social-media-logos/deezer.png",
        statistics: {
          fans: {
            title: "Fans",
            value: 2661262,
            rank: 4,
          },
        },
      },
      shazam: {
        socialMedia: "Shazam",
        icon: "social-media-logos/shazam.png",
        statistics: {
          totalCount: {
            title: "Total Count",
            value: 2661262,
          },
        },
      },
      line: {
        socialMedia: "LINE",
        icon: "social-media-logos/line.png",
        statistics: {
          artistLikes: {
            title: "Artist Likes",
            value: 2661262,
            rank: 248,
          },
          likes: {
            title: "Likes",
            value: 2661262,
            rank: 261,
          },
          plays: {
            title: "Plays",
            value: 2661262,
            rank: 252,
          },
          musicVideoPlays: {
            title: "Music Video Plays",
            value: 2661262,
            rank: 328,
          },
        },
      },
    },
    artist: {
      id: 839964,
      name: "Nirvana",
      biography: `Rising from the streets of Compton but with a distinct Southern flair, rapper Roddy Ricch lays his introspective rhymes atop melodic trap, 
      resulting in a hybrid form that has captured the ears of both regions. The MC broke through in 2018 with the platinum single "Die Young" and topped the 
      Billboard 200 the next year with Please Excuse Me for Being AntiSocial. Sophomore album Live Life Fast arrived in December 2021. Both that record and the 
      2022 mixtape Feed tha Streets III broke into the upper reaches of the charts.`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 9386911,
              rank: 207,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 23002641,
              rank: 212,
            },
            popularity: {
              title: "Popularity",
              value: 79,
              rank: 251,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 205872707,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "40.81%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "21.93x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7152250,
              rank: 1058,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5400000,
              rank: 578,
              monthly_diff: {
                value: 0,
                percentage: 0,
              },
            },
            likes: {
              title: "Likes",
              value: 18500000,
              rank: 2173,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 10732294558,
              rank: 144,
            },
            postCount: {
              title: "Post Count",
              value: 13720262,
              rank: 74,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 6700000,
              rank: 616,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2940431924,
              rank: 617,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1085270,
              rank: 886,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 32786835,
              rank: 869,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2683777,
              rank: 211,
            },
            streams: {
              title: "Streams",
              value: 1109384927,
              rank: 635,
            },
            artistStations: {
              title: "Artist Stations",
              value: 2511774,
              rank: 784,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 672490,
              rank: 933,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 48810362,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 1916,
              rank: 1465,
            },
            likes: {
              title: "Likes",
              value: 11014,
              rank: 1137,
            },
            plays: {
              title: "Plays",
              value: 1155570,
              rank: 1145,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1330,
              rank: 663,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 3188,
              rank: 890,
            },
            likes: {
              title: "Likes",
              value: 32233,
              rank: 688,
            },
            videoLikes: {
              title: "Video Likes",
              value: 49,
              rank: 607,
            },
            videoViews: {
              title: "Video Views",
              value: 5173,
              rank: 602,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 14023863,
            },
          },
        },
      },
    },
    status: "finished",/*"progress",*/
  },
  {
    auctionID: 3569,
    title: "Fear Of The Dawn",
    artist: "180 grams",
    description: `Fear of the Dawn is the fourth studio album from Jack White, founding member of The White Stripes, 
                  The Raconteurs, and The Dead Weather. True to his DIY roots, this record was recorded at White's 
                  Third Man Studio throughout 2021, mastered by Third Man Mastering.`,

    genre: ["Rock", "American"],
    startDate: "04/05/2023 00:00:00",
    endDate: "04/10/2023 22:00:00",
    units: 300000,
    minAuctionTarget: 300000,
    minOrder: 50,
    spotifyLink: "https://open.spotify.com/album/46qeiLBu3KwqFQpJBT7t6B",
    imgSrc: [
      "auctions/that-was-then-1.jpg",
      "auctions/morning.jpg",
      "auctions/jack-white-3.jpg",
    ],
    metrics: {
      spotify: 174480,
      instagram: 5640,
    },
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$14,510",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$20,817",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "BMI, ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/fPA67w3J_g0",
        thumbnail: "tracks/hi-de-ho.png",
      },
      {
        link: "https://www.youtube.com/embed/W9uDS2RPDtg",
        thumbnail: "tracks/morning.png",
      },
      {
        link: "https://www.youtube.com/embed/W25FyqFPC6I",
        thumbnail: "tracks/that-was-then.png",
      },
      {
        link: "https://www.youtube.com/embed/WOZwxqQlyLg",
        thumbnail: "tracks/whats-the-trick.png",
      },
    ],
    tracks: [
      {
        id: "75286809",
        isrc: "US3JJ2100665",
        title: "Hi-De-Ho",
        artist: "Jack White",
        album: "Fear Of The Dawn",
        releaseDate: "03/02/2022",
        imgSrc: "auctions/hi-de-ho.png",
        spotifyLink: "https://open.spotify.com/track/3GkZwRXM2Dsd8c25qYSmGU",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 182,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1837717,
              },
              likes: {
                title: "Likes",
                value: 557700738,
              },
              views: {
                title: "Views",
                value: 4011733883,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 72,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 153164790,
              },
              streams: {
                title: "Streams",
                value: 1660569609,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 261405758,
              },
              likes: {
                title: "Likes",
                value: 2280842,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4840523,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 3031,
              },
              count: {
                title: "Listen Count",
                value: 401756,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 41359,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 76068,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 72,
              },
            },
          },
        },
      },
      {
        id: "79457527",
        isrc: "US3JJ2100667",
        title: "Into the Twilight",
        artist: "Jack White",
        album: "Jack White",
        releaseDate: "04/07/2022",
        spotifyLink: "https://open.spotify.com/track/3Crza2L6GItXsfmd0U8hHI",
        imgSrc: "auctions/fear-of-the-down.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 330,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 760075,
              },
              likes: {
                title: "Likes",
                value: 26613301,
              },
              views: {
                title: "Views",
                value: 169701540,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 29819812,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 345119603,
              },
              trackStations: {
                title: "Track Stations",
                value: 181540,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 90,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 69666434,
              },
              streams: {
                title: "Streams",
                value: 1618660529,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 253788281,
              },
              likes: {
                title: "Likes",
                value: 2602019,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3669803,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 10519870,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 922419,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 23840,
              },
              count: {
                title: "Listen Count",
                value: 2282556,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 32219,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 26199,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 79,
              },
            },
          },
        },
      },
      {
        id: "75320052",
        isrc: "US3JJ2100664",
        title: "The White Raven",
        artist: "Jack White",
        album: "Fear Of The Dawn",
        releaseDate: "10/24/2000",
        spotifyLink: "https://open.spotify.com/track/3C1ELJIcYJUOCp7L9Ogk6T",
        imgSrc: "auctions/fear-of-the-down.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 210,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 399812,
              },
              likes: {
                title: "Likes",
                value: 49990312,
              },
              views: {
                title: "Views",
                value: 558897298,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 26291074,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 88,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 79150026,
              },
              streams: {
                title: "Streams",
                value: 1570623945,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 2035883007,
              },
              likes: {
                title: "Likes",
                value: 15824027,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 2099167,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 25031,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2764583,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 5219,
              },
              count: {
                title: "Listen Count",
                value: 617281,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 12519,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 165241,
              },
            },
          },
        },
      },
      {
        id: "79457241",
        isrc: "US3JJ2100666",
        title: "Eosophobia",
        artist: "Jack White",
        album: "	Fear Of The Dawn",
        releaseDate: "04/07/2022",
        spotifyLink: "https://open.spotify.com/track/0YBfKLk3Edwu4sY0iyIYsd",
        imgSrc: "auctions/fear-of-the-down.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 287,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 93228,
              },
              likes: {
                title: "Likes",
                value: 39772162,
              },
              views: {
                title: "Views",
                value: 278621708,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 2610968,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 752966228,
              },
              trackStations: {
                title: "Track Stations",
                value: 339730,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 134255792,
              },
              streams: {
                title: "Streams",
                value: 1757100670,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 136268788,
              },
              likes: {
                title: "Likes",
                value: 1415769,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3494539,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 7413136,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2886102,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 186168,
              },
            },
          },
        },
      },
      {
        id: "79463249",
        isrc: "US3JJ2100673",
        title: "Shedding My Velvet",
        artist: "Jack White",
        album: "Fear Of The Dawn",
        releaseDate: "04/07/2022",
        spotifyLink: "https://open.spotify.com/track/0SgYcCu6eMI3zwhbobAENd",
        imgSrc: "auctions/fear-of-the-down.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 289,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 123878,
              },
              likes: {
                title: "Likes",
                value: 27481402,
              },
              views: {
                title: "Views",
                value: 213826453,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 46305318,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 564229863,
              },
              trackStations: {
                title: "Track Stations",
                value: 407093,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 45292740,
              },
              streams: {
                title: "Streams",
                value: 836046887,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 315234433,
              },
              likes: {
                title: "Likes",
                value: 2327031,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 1306909,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 3288014,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 185027,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 674,
              },
              count: {
                title: "Listen Count",
                value: 77490,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 14973,
              },
            },
          },
        },
      },
    ],
    artist: {
      id: 839964,
      name: "Jack White",
      biography: `Rising from the streets of Compton but with a distinct Southern flair, rapper Roddy Ricch lays his introspective rhymes atop melodic trap, 
      resulting in a hybrid form that has captured the ears of both regions. The MC broke through in 2018 with the platinum single "Die Young" and topped the 
      Billboard 200 the next year with Please Excuse Me for Being AntiSocial. Sophomore album Live Life Fast arrived in December 2021. Both that record and the 
      2022 mixtape Feed tha Streets III broke into the upper reaches of the charts.`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 9386911,
              rank: 207,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 23002641,
              rank: 212,
            },
            popularity: {
              title: "Popularity",
              value: 79,
              rank: 251,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 205872707,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "40.81%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "21.93x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7152250,
              rank: 1058,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5400000,
              rank: 578,
              monthly_diff: {
                value: 0,
                percentage: 0,
              },
            },
            likes: {
              title: "Likes",
              value: 18500000,
              rank: 2173,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 10732294558,
              rank: 144,
            },
            postCount: {
              title: "Post Count",
              value: 13720262,
              rank: 74,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 6700000,
              rank: 616,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2940431924,
              rank: 617,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1085270,
              rank: 886,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 32786835,
              rank: 869,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2683777,
              rank: 211,
            },
            streams: {
              title: "Streams",
              value: 1109384927,
              rank: 635,
            },
            artistStations: {
              title: "Artist Stations",
              value: 2511774,
              rank: 784,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 672490,
              rank: 933,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 48810362,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 1916,
              rank: 1465,
            },
            likes: {
              title: "Likes",
              value: 11014,
              rank: 1137,
            },
            plays: {
              title: "Plays",
              value: 1155570,
              rank: 1145,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1330,
              rank: 663,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 3188,
              rank: 890,
            },
            likes: {
              title: "Likes",
              value: 32233,
              rank: 688,
            },
            videoLikes: {
              title: "Video Likes",
              value: 49,
              rank: 607,
            },
            videoViews: {
              title: "Video Views",
              value: 5173,
              rank: 602,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 14023863,
            },
          },
        },
      },
    },
    status: "finished"/*"scheduled",*/
  },
  {
    auctionID: 3570,
    title: `What's The Story Morning Glory?`,
    artist: "Oasis",
    description: `(What's The Story) Morning Glory?, the follow-up to the debut album Definitely Maybe, 
                  is Oasis' biggest-selling album with 22 million copies sold worldwide. It was recorded 
                  between May and June 1995 in Rockfield Studios, Monmouthshire, with Owen Morris and Noel 
                  Gallagher producing. Released on October 2nd 1995 it spent 10 weeks at No.1, is the 5th 
                  biggest-selling album in UK chart history and became the band's breakthrough album in the 
                  US where it sold 4 million copies. `,

    genre: ["Rock", "American"],
    spotifyLink: "https://open.spotify.com/album/2u30gztZTylY4RG7IvfXs8",
    startDate: "05/02/2023 00:00:00",
    endDate: "05/10/2023 22:00:00",
    units: 300000,
    minAuctionTarget: 300000,
    minOrder: 50,
    imgSrc: [
      "auctions/oasis-1.jpg",
      "auctions/oasis-2.jpg",
      "auctions/oasis-3.jpg",
    ],
    metrics: {
      spotify: 174480,
      instagram: 5640,
    },
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$14,510",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$20,817",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "BMI, ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/Wm54XyLwBAk",
        thumbnail: "tracks/bonehead.png",
      },
      {
        link: "https://www.youtube.com/embed/oxOjIj18I9E",
        thumbnail: "tracks/some-might-say.png",
      },
      {
        link: "https://www.youtube.com/embed/DrARl0dzd-0",
        thumbnail: "tracks/roll-with.png",
      },
    ],
    tracks: [
      {
        id: "12436711",
        isrc: "GBAAW9500197",
        title: "Champagne Supernova",
        artist: "Oasis",
        album: "(What's The Story) Morning Glory?",
        releaseDate: "10/01/1995",
        imgSrc: "auctions/oasis-1.jpg",
        spotifyLink: "https://open.spotify.com/track/0OTs7C7ersyvy8FKjfnrwj",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 182,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1837717,
              },
              likes: {
                title: "Likes",
                value: 557700738,
              },
              views: {
                title: "Views",
                value: 4011733883,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 72,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 153164790,
              },
              streams: {
                title: "Streams",
                value: 1660569609,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 261405758,
              },
              likes: {
                title: "Likes",
                value: 2280842,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4840523,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 3031,
              },
              count: {
                title: "Listen Count",
                value: 401756,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 41359,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 76068,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 72,
              },
            },
          },
        },
      },
      {
        id: "12436704",
        isrc: "12436704",
        title: "Wonderwall",
        artist: "Oasis",
        album: "(What's The Story) Morning Glory?",
        releaseDate: "10/01/1995",
        spotifyLink: "https://open.spotify.com/track/6C6Djv7h1UqElnByZILiF0",
        imgSrc: "auctions/oasis-1.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 330,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 760075,
              },
              likes: {
                title: "Likes",
                value: 26613301,
              },
              views: {
                title: "Views",
                value: 169701540,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 29819812,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 345119603,
              },
              trackStations: {
                title: "Track Stations",
                value: 181540,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 90,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 69666434,
              },
              streams: {
                title: "Streams",
                value: 1618660529,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 253788281,
              },
              likes: {
                title: "Likes",
                value: 2602019,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3669803,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 10519870,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 922419,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 23840,
              },
              count: {
                title: "Listen Count",
                value: 2282556,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 32219,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 26199,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 79,
              },
            },
          },
        },
      },
      {
        id: "12436705",
        isrc: "12436705",
        title: `Don't Look Back In Anger`,
        artist: "Oasis",
        album: "(What's The Story) Morning Glory?",
        releaseDate: "10/01/1995",
        spotifyLink: "https://open.spotify.com/track/0qjZrmaFF5h6oQlolBCiUM",
        imgSrc: "auctions/oasis-1.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 210,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 399812,
              },
              likes: {
                title: "Likes",
                value: 49990312,
              },
              views: {
                title: "Views",
                value: 558897298,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 26291074,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 88,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 79150026,
              },
              streams: {
                title: "Streams",
                value: 1570623945,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 2035883007,
              },
              likes: {
                title: "Likes",
                value: 15824027,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 2099167,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 25031,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2764583,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 5219,
              },
              count: {
                title: "Listen Count",
                value: 617281,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 12519,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 165241,
              },
            },
          },
        },
      },
      {
        id: "12597672",
        isrc: "GBBQY9502012",
        title: "Hello",
        artist: "Oasis",
        album: "	(What's The Story) Morning Glory?",
        releaseDate: "10/01/1995",
        spotifyLink: "https://open.spotify.com/track/1hKSayDqvGY9Bnrx3ytZRm",
        imgSrc: "auctions/oasis-1.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 287,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 93228,
              },
              likes: {
                title: "Likes",
                value: 39772162,
              },
              views: {
                title: "Views",
                value: 278621708,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 2610968,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 752966228,
              },
              trackStations: {
                title: "Track Stations",
                value: 339730,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 134255792,
              },
              streams: {
                title: "Streams",
                value: 1757100670,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 136268788,
              },
              likes: {
                title: "Likes",
                value: 1415769,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3494539,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 7413136,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2886102,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 186168,
              },
            },
          },
        },
      },
      {
        id: "12436708",
        isrc: "GBAAW9500194",
        title: "Cast No Shadow",
        artist: "Oasis",
        album: "(What's The Story) Morning Glory?",
        releaseDate: "10/01/1995",
        spotifyLink: "https://open.spotify.com/track/16aFyP3MwyFPTyg3pfBF2q",
        imgSrc: "auctions/oasis-1.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 289,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 123878,
              },
              likes: {
                title: "Likes",
                value: 27481402,
              },
              views: {
                title: "Views",
                value: 213826453,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 46305318,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 564229863,
              },
              trackStations: {
                title: "Track Stations",
                value: 407093,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 45292740,
              },
              streams: {
                title: "Streams",
                value: 836046887,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 315234433,
              },
              likes: {
                title: "Likes",
                value: 2327031,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 1306909,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 3288014,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 185027,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 674,
              },
              count: {
                title: "Listen Count",
                value: 77490,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 14973,
              },
            },
          },
        },
      },
    ],
    artist: {
      id: 839964,
      name: "Oasis",
      biography: `Rising from the streets of Compton but with a distinct Southern flair, rapper Roddy Ricch lays his introspective rhymes atop melodic trap, 
      resulting in a hybrid form that has captured the ears of both regions. The MC broke through in 2018 with the platinum single "Die Young" and topped the 
      Billboard 200 the next year with Please Excuse Me for Being AntiSocial. Sophomore album Live Life Fast arrived in December 2021. Both that record and the 
      2022 mixtape Feed tha Streets III broke into the upper reaches of the charts.`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 9386911,
              rank: 207,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 23002641,
              rank: 212,
            },
            popularity: {
              title: "Popularity",
              value: 79,
              rank: 251,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 205872707,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "40.81%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "21.93x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7152250,
              rank: 1058,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5400000,
              rank: 578,
              monthly_diff: {
                value: 0,
                percentage: 0,
              },
            },
            likes: {
              title: "Likes",
              value: 18500000,
              rank: 2173,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 10732294558,
              rank: 144,
            },
            postCount: {
              title: "Post Count",
              value: 13720262,
              rank: 74,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 6700000,
              rank: 616,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2940431924,
              rank: 617,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1085270,
              rank: 886,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 32786835,
              rank: 869,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2683777,
              rank: 211,
            },
            streams: {
              title: "Streams",
              value: 1109384927,
              rank: 635,
            },
            artistStations: {
              title: "Artist Stations",
              value: 2511774,
              rank: 784,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 672490,
              rank: 933,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 48810362,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 1916,
              rank: 1465,
            },
            likes: {
              title: "Likes",
              value: 11014,
              rank: 1137,
            },
            plays: {
              title: "Plays",
              value: 1155570,
              rank: 1145,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1330,
              rank: 663,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 3188,
              rank: 890,
            },
            likes: {
              title: "Likes",
              value: 32233,
              rank: 688,
            },
            videoLikes: {
              title: "Video Likes",
              value: 49,
              rank: 607,
            },
            videoViews: {
              title: "Video Views",
              value: 5173,
              rank: 602,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 14023863,
            },
          },
        },
      },
    },
    status: "finished"/*"scheduled",*/
  },
  {
    auctionID: 3571,
    title: `Lazaretto`,
    artist: "Jack White",
    description: `2014 album from the singer, songwriter, producer and label owner. LAZARETTO isthe follow up to his Gold-certified debut album, BLUNDERBUSS. 
                      Jack has sold over 7.5 Million records (solo material, the White Stripes, the Raconteurs and the Dead Weather) and his previous solo effor 
                      was nominated for`,

    genre: ["Rock", "American"],
    spotifyLink: "https://open.spotify.com/album/6Fjr6WmxRcWW8GZpU5ciKE",
    startDate: "05/11/2023 00:00:00",
    endDate: "05/20/2023 22:00:00",
    units: 300000,
    minAuctionTarget: 300000,
    minOrder: 50,

    imgSrc: [
      "auctions/lazaretto-1.jpg",
      "auctions/lazaretto-2.jpg",
      "auctions/lazaretto-3.jpg",
    ],
    metrics: {
      spotify: 174480,
      instagram: 5640,
    },
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$14,510",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$20,817",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "BMI, ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/bT2z1bKM6dM",
        thumbnail: "tracks/want-and-able.png",
      },
      {
        link: "https://www.youtube.com/embed/i-8B-_Jq2ro",
        thumbnail: "tracks/lazzareto.png",
      },
      {
        link: "https://www.youtube.com/embed/qI-95cTMeLM",
        thumbnail: "tracks/entitlement.png",
      },
      {
        link: "https://www.youtube.com/embed/sRbnAxrS3EM",
        thumbnail: "tracks/alone.png",
      },
      {
        link: "https://www.youtube.com/embed/pTN_Axw8TJA",
        thumbnail: "tracks/three-woman.png",
      },
    ],
    tracks: [
      {
        id: "15793134",
        isrc: "USSM11401498",
        title: "Lazaretto",
        artist: "Jack White",
        album: "Lazaretto",
        releaseDate: "04/21/2014",
        imgSrc: "auctions/lazaretto.jpg",
        spotifyLink: "https://open.spotify.com/track/41qHerpo9DI6LHo13MIIy4",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 182,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 1837717,
              },
              likes: {
                title: "Likes",
                value: 557700738,
              },
              views: {
                title: "Views",
                value: 4011733883,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 72,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 153164790,
              },
              streams: {
                title: "Streams",
                value: 1660569609,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 261405758,
              },
              likes: {
                title: "Likes",
                value: 2280842,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 4840523,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 3031,
              },
              count: {
                title: "Listen Count",
                value: 401756,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 41359,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 76068,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 72,
              },
            },
          },
        },
      },
      {
        id: "15793136",
        isrc: "USSM11401500",
        title: "Would You Fight For My Love?",
        artist: "Jack White",
        album: "Lazaretto",
        releaseDate: "06/08/2014",
        spotifyLink: "https://open.spotify.com/track/4CoKP2Ne3Qvixa58AHyFnN",
        imgSrc: "auctions/lazaretto.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 330,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 760075,
              },
              likes: {
                title: "Likes",
                value: 26613301,
              },
              views: {
                title: "Views",
                value: 169701540,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 29819812,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 345119603,
              },
              trackStations: {
                title: "Track Stations",
                value: 181540,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 90,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 69666434,
              },
              streams: {
                title: "Streams",
                value: 1618660529,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 253788281,
              },
              likes: {
                title: "Likes",
                value: 2602019,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3669803,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 10519870,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 922419,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 23840,
              },
              count: {
                title: "Listen Count",
                value: 2282556,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 32219,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 26199,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 79,
              },
            },
          },
        },
      },
      {
        id: "15793137",
        isrc: "USSM11401501",
        title: `High Ball Stepper`,
        artist: "Jack White",
        album: "Lazaretto",
        releaseDate: "04/07/2014",
        spotifyLink: "https://open.spotify.com/track/5rKRDWJXZKovTfcWun3uR5",
        imgSrc: "auctions/lazaretto.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 210,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 399812,
              },
              likes: {
                title: "Likes",
                value: 49990312,
              },
              views: {
                title: "Views",
                value: 558897298,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 26291074,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 88,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 79150026,
              },
              streams: {
                title: "Streams",
                value: 1570623945,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 2035883007,
              },
              likes: {
                title: "Likes",
                value: 15824027,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 2099167,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 25031,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2764583,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 5219,
              },
              count: {
                title: "Listen Count",
                value: 617281,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 12519,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 165241,
              },
            },
          },
        },
      },
      {
        id: "15793139",
        isrc: "USSM11401503",
        title: "Alone In My Home",
        artist: "Jack White",
        album: "Lazaretto",
        releaseDate: "06/08/2014",
        spotifyLink: "https://open.spotify.com/track/7ztBSiUoGOT3DhsE5b9Kha",
        imgSrc: "auctions/lazaretto.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 287,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 93228,
              },
              likes: {
                title: "Likes",
                value: 39772162,
              },
              views: {
                title: "Views",
                value: 278621708,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 2610968,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 752966228,
              },
              trackStations: {
                title: "Track Stations",
                value: 339730,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 134255792,
              },
              streams: {
                title: "Streams",
                value: 1757100670,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 136268788,
              },
              likes: {
                title: "Likes",
                value: 1415769,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3494539,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 7413136,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 2886102,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 186168,
              },
            },
          },
        },
      },
      {
        id: "15793141",
        isrc: "USSM11401505",
        title: "That Black Bat Licorice",
        artist: "Jack White",
        album: "Lazaretto",
        releaseDate: "06/08/2014",
        spotifyLink: "https://open.spotify.com/track/0LF83MKSF3QyVlfXZWMsWW",
        imgSrc: "auctions/lazaretto.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 289,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 123878,
              },
              likes: {
                title: "Likes",
                value: 27481402,
              },
              views: {
                title: "Views",
                value: 213826453,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 46305318,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 564229863,
              },
              trackStations: {
                title: "Track Stations",
                value: 407093,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 45292740,
              },
              streams: {
                title: "Streams",
                value: 836046887,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 315234433,
              },
              likes: {
                title: "Likes",
                value: 2327031,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 1306909,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 3288014,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 185027,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 674,
              },
              count: {
                title: "Listen Count",
                value: 77490,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 14973,
              },
            },
          },
        },
      },
    ],
    artist: {
      id: 839964,
      name: "Jack White",
      biography: `Rising from the streets of Compton but with a distinct Southern flair, rapper Roddy Ricch lays his introspective rhymes atop melodic trap, 
      resulting in a hybrid form that has captured the ears of both regions. The MC broke through in 2018 with the platinum single "Die Young" and topped the 
      Billboard 200 the next year with Please Excuse Me for Being AntiSocial. Sophomore album Live Life Fast arrived in December 2021. Both that record and the 
      2022 mixtape Feed tha Streets III broke into the upper reaches of the charts.`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 9386911,
              rank: 207,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 23002641,
              rank: 212,
            },
            popularity: {
              title: "Popularity",
              value: 79,
              rank: 251,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 205872707,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "40.81%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "21.93x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7152250,
              rank: 1058,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5400000,
              rank: 578,
              monthly_diff: {
                value: 0,
                percentage: 0,
              },
            },
            likes: {
              title: "Likes",
              value: 18500000,
              rank: 2173,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 10732294558,
              rank: 144,
            },
            postCount: {
              title: "Post Count",
              value: 13720262,
              rank: 74,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 6700000,
              rank: 616,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2940431924,
              rank: 617,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1085270,
              rank: 886,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 32786835,
              rank: 869,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2683777,
              rank: 211,
            },
            streams: {
              title: "Streams",
              value: 1109384927,
              rank: 635,
            },
            artistStations: {
              title: "Artist Stations",
              value: 2511774,
              rank: 784,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 672490,
              rank: 933,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 48810362,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 1916,
              rank: 1465,
            },
            likes: {
              title: "Likes",
              value: 11014,
              rank: 1137,
            },
            plays: {
              title: "Plays",
              value: 1155570,
              rank: 1145,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1330,
              rank: 663,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 3188,
              rank: 890,
            },
            likes: {
              title: "Likes",
              value: 32233,
              rank: 688,
            },
            videoLikes: {
              title: "Video Likes",
              value: 49,
              rank: 607,
            },
            videoViews: {
              title: "Video Views",
              value: 5173,
              rank: 602,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 14023863,
            },
          },
        },
      },
    },
    status:"finished" /*"scheduled",*/
  },
  {
    auctionID: 2183,
    title: `The Street Band`,
    artist: "Bruce Springsteen",
    description: `"Born in the U.S.A." is a song written and performed by Bruce Springsteen, and released in 1984 on the album of the same name. One of Springsteen's
                        best-known singles, it was ranked 275th on Rolling Stones's list of "The 500 Greatest Songs of All Time", and in 2001, the RIAA's Songs of the Century
                        placed the song 59th (out of 365), remaining a favorite in classic rock. The song addresses the economic hardships of Vietnam veterans upon their 
                        return home, juxtaposed ironically against patriotic glorification of the nation's fighting forces.`,
    startDate: "05/11/2023 00:00:00",
    endDate: "05/20/2023 22:00:00",
    genre: ["Rock", "American"],
    units: 300000,
    minAuctionTarget: 300000,
    spotifyLink: "https://open.spotify.com/album/0PMasrHdpaoIRuHuhHp72O",
    minOrder: 50,

    imgSrc: [
      "auctions/the-street-band-1.jpg",
      "auctions/the-street-band-2.jpg",
      "auctions/the-street-band-3.jpg",
    ],
    metrics: {
      spotify: 174480,
      instagram: 5640,
    },
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$14,510",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$20,817",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "3.5 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "BMI, ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/bT2z1bKM6dM",
        thumbnail: "auctions/the-street-band.jpg",
      },
      {
        link: "https://www.youtube.com/embed/UDIDawmeeI0",
        thumbnail: "auctions/the-street-band.jpg",
      },
      {
        link: "https://www.youtube.com/embed/ifi5Uf73bec",
        thumbnail: "auctions/the-street-band.jpg",
      },
      {
        link: "https://www.youtube.com/embed/WCA-3uu3jqc",
        thumbnail: "auctions/the-street-band.jpg",
      },
      {
        link: "https://www.youtube.com/embed/O0jBwk71Qcw",
        thumbnail: "auctions/the-street-band.jpg",
      },
    ],
    tracks: [
      {
        id: "41226160",
        title: `Born in the U.S.A.`,
        artist: "Bruce Springsteen",
        album: `Born in the U.S.A.`,
        releaseDate: "12/12/1998",
        imgSrc: "auctions/the-street-band-1.jpg",
      },
      {
        id: "19721875",
        title: `Walking on the moon`,
        artist: "Bruce Springsteen",
        album: `Born in the U.S.A.`,
        releaseDate: "12/12/1998",
        imgSrc: "auctions/the-street-band-1.jpg",
      },
      {
        id: "42131246",
        title: `Elliot and the fish`,
        artist: "Bruce Springsteen",
        album: `Born in the U.S.A.`,
        releaseDate: "12/12/1998",
        imgSrc: "auctions/the-street-band-1.jpg",
      },
      {
        id: "41031646",
        title: `Plain with me`,
        artist: "Bruce Springsteen",
        album: `Born in the U.S.A.`,
        releaseDate: "12/12/1998",
        imgSrc: "auctions/the-street-band-2.jpg",
      },
      {
        id: "42032746",
        title: `Where does it end`,
        artist: "Bruce Springsteen",
        album: `Born in the U.S.A.`,
        releaseDate: "12/12/1998",
        imgSrc: "auctions/the-street-band-3.jpg",
      },
    ],
    status: "finished"/*"progress",*/
  },

  {
    auctionID: 6881,
    symbolID: "TMA_OI",
    symbolType: "Part of an album",
    title: "Thinking Out Loud",
    genre: ["Pop", "Singer/Songwriter"],
    spotifyLink: "https://open.spotify.com/track/3cw4Y2ziYYiJV49bWN5H1D",
    description: `"Thinking Out Loud" is a song by English singer-songwriter Ed Sheeran recorded for his second studio album, x 
    (2014). It was written by Julian Williams, Sheeran and Amy Wadge, and produced by frequent collaborator Jake Gosling. It was 
    released in the US on 24 September 2014 as the album's third single.`,
    startDate: "05/12/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 100,
    minAuctionTarget: 300000,
    minOrder: 50,
    currentPrice: "$14.35",
    priceIncrease: "$0.02",
    averageYield: "10%",
    LTMYield: "8.5%",
    lastPrice: "$14.35",
    weeklyVolume: "45",
    change: "3.01%",
    dalyGain: "$0.02",
    totalGain: "$7.8",
    royalties: "$12.39",
    aveCost: "$7.8",
    orderType: "Auction",
    bidPerUnit: "$6.70",
    bidUnits: "34",
    bidValue: "$1,921",
    askPerUnit: "$14",
    askUnits: "101",
    imgSrc: ["auctions/thinking-out-loud.png"],
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$200,000",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$16,000",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "12.01 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Part of an album",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "1",
      },
      {
        title: "Record lable",
        description: "Atlantic Records",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/lp-EO5I60KA",
        thumbnail: "tracks/thinking-out-loud.jpg",
      },
    ],
    tracks: [
      {
        id: "12449356",
        isrc: "GBAHS1400099",
        title: "Thinking Out Loud",
        artist: "Ed Sheeran",
        album: "Full Circle: The Live Anthology",
        releaseDate: "11/19/2011",
        spotifyLink: "https://open.spotify.com/track/0k4nrrCsMr0Tao5WvQ8Osq",
        imgSrc: "tracks/thinking-out-loud.png",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 2000,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 5003604,
              },
              likes: {
                title: "Likes",
                value: 516146337,
              },
              views: {
                title: "Views",
                value: 4114763138,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 161095443,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 257597084,
              },
              trackStations: {
                title: "Track Stations",
                value: 609002,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 83,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 69898713,
              },
              streams: {
                title: "Streams",
                value: 1634347508,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1182153699,
              },
              likes: {
                title: "Likes",
                value: 15105438,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3398236,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 9581043,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 563690,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 5731,
              },
              count: {
                title: "Listen Count",
                value: 631090,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 23878,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 748933,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://rapradar.com/2023/03/31/album-dj-drama-im-really-like-that/",
        title: "Album: DJ Drama ‘I’m Really Like That”",
        source: "Rap Radar",
        image_url:
          "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
        date: "2023-03-31T04:04:00.000Z",
      },
      {
        url: "https://www.billboard.com/lists/song-of-the-summer-2023-early-contenders/",
        title:
          "Way-Too-Early Song of the Summer 2023 Contenders: The Front-Runners, Outside Shots & Question Marks",
        source: "billboard",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
        date: "2023-03-30T19:55:01.000Z",
      },
      {
        url: "https://allhiphop.com/news/tyler-the-creator-explains-why-being-a-rapper-is-awesome/",
        title: "Tyler, The Creator Explains Why Being A Rapper Is “Awesome”",
        source: "AllHipHop",
        image_url:
          "https://video.primis.tech/uploads/video/users/logo/30526/logo_9860.png?cbuster=1616405498",
        date: "2023-03-30T12:33:30.000Z",
      },
      {
        url: "https://www.okayplayer.com/music/tyler-the-creator-sorry-not-sorry.html",
        title:
          "Watch Tyler, the Creator Channel All His Eras In the “Sorry Not Sorry” Music Video",
        source: "Okayplayer",
        image_url:
          "https://yt3.ggpht.com/ytc/AMLnZu9tabEaPKboW0n_5riHUHmVsHtycyBU6zvmlKnTpg=s88-c-k-c0x00ffffff-no-rj",
        date: "2023-03-29T16:54:24.000Z",
      },
      {
        url: "https://www.complex.com/music/best-new-music-this-week-march-6lack-bia-chloe/",
        title: "The Best New Music This Week: 6LACK, BIA, Chlöe, and More",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-24T19:02:52.000Z",
      },
      {
        url: "https://www.complex.com/music/internet-money-kodak-black-roddy-ricch-i-remember",
        title:
          'Internet Money Enlists Kodak Black and Roddy Ricch for New Single "I Remember"',
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-24T16:37:30.000Z",
      },
      {
        url: "https://www.clashmusic.com/news/internet-money-link-with-roddy-ricch-kodak-black-on-i-remember/",
        title:
          "Internet Money Link With Roddy Ricch, Kodak Black On ‘I Remember’",
        source: "Clash",
        image_url:
          "https://www.clashmusic.com/wp-content/themes/chop-child/images/clash-logo.png",
        date: "2023-03-24T11:30:50.000Z",
      },
      {
        url: "https://rapradar.com/2023/03/24/internet-money-ft-roddy-ricch-kodak-black-i-remember/",
        title: "Internet Money Ft. Roddy Ricch, Kodak Black “I Remember”",
        source: "Rap Radar",
        image_url:
          "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
        date: "2023-03-24T04:10:00.000Z",
      },
      {
        url: "https://streamlinemusicblog.com/2023/03/23/wpvr-ny-featured-music-schedule-03-24-23/",
        title:
          "WPVR NY Platinum Vibes Radio: FEATURED MUSIC AIRPLAY SCHEDULE – March 24, 2023",
        source: "StreamLINE Music Blog",
        image_url:
          "https://i1.wp.com/streamlinemusicblog.com/wp-content/uploads/2019/06/cropped-cropped-STREAMLINE-LOGO_500W.png?w=240&ssl=1",
        date: "2023-03-24T01:17:57.000Z",
      },
      {
        url: "https://streamlinemusicblog.com/2023/03/23/naqt-vane-first-digital-ep-chronic-music-video/",
        title:
          "Japan’s NAQT VANE release first digital EP, ‘NAQT’! Vocalist Harukaze and producer Hiroyuki SAWANO feature in ‘CHRONIC’ music video, directed by Classic 6!",
        source: "StreamLINE Music Blog",
        image_url:
          "https://i1.wp.com/streamlinemusicblog.com/wp-content/uploads/2019/06/cropped-cropped-STREAMLINE-LOGO_500W.png?w=240&ssl=1",
        date: "2023-03-23T20:21:00.000Z",
      },
      {
        url: "https://allhiphop.com/news/watch-the-trailer-for-hulus-rapcaviar-presents-featuring-tyler-the-creator-city-girls-more/",
        title:
          "Watch The Trailer For Hulu’s ‘RapCaviar Presents’ Featuring Tyler The Creator, City Girls & More",
        source: "AllHipHop",
        image_url:
          "https://video.primis.tech/uploads/video/users/logo/30526/logo_9860.png?cbuster=1616405498",
        date: "2023-03-23T13:52:56.000Z",
      },
    ],
    artist: {
      id: 839964,
      name: "Ed Sheeran",
      biography: `Ed Sheeran may be the quintessential pop star of the 2010s: a singer/songwriter who doesn't seem to acknowledge boundaries between 
      styles or eras, creating a sound that's idiosyncratic and personal. He borrows from any style that crosses his path -- elements of folk, hip-hop, 
      pop, dance, soul, and rock can be heard in his big hits "The A Team," "Sing," "Thinking Out Loud," and "Shape of You" -- which gives him a broad 
      appeal among different demographics. It also helped elevate him to international acclaim not long after the release of his 2011 debut, +, and took 
      2014's x and 2017's ÷ to the top of both the U.K. albums chart and the Billboard 200. Sheeran maintained his stardom with savvy collaborations -- 
      his 2019 album No. 6 Collaborations Project featured an eclectic roster including Khalid , Camila Cabello , Cardi B , Justin Bieber , Chris Stapleton , 
      and Bruno Mars -- and by continuing to write candidly about his life: his 2021 album = was filled with songs about being a new father. Sheeran's 
      musical explorations continued on -, a 2023 album that featured several tracks co-written and co-produced by Aaron Dessner of the National .`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 9386911,
              rank: 207,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 1600000000,
              rank: 212,
            },
            popularity: {
              title: "Popularity",
              value: 79,
              rank: 251,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 205872707,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "40.81%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "21.93x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7152250,
              rank: 1058,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5400000,
              rank: 578,
              monthly_diff: {
                value: 0,
                percentage: 0,
              },
            },
            likes: {
              title: "Likes",
              value: 18500000,
              rank: 2173,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 10732294558,
              rank: 144,
            },
            postCount: {
              title: "Post Count",
              value: 13720262,
              rank: 74,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 6700000,
              rank: 616,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2940431924,
              rank: 617,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1085270,
              rank: 886,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 1200000000,
              rank: 869,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2683777,
              rank: 211,
            },
            streams: {
              title: "Streams",
              value: 1109384927,
              rank: 635,
            },
            artistStations: {
              title: "Artist Stations",
              value: 2511774,
              rank: 784,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 672490,
              rank: 933,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 48810362,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 1916,
              rank: 1465,
            },
            likes: {
              title: "Likes",
              value: 11014,
              rank: 1137,
            },
            plays: {
              title: "Plays",
              value: 1155570,
              rank: 1145,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1330,
              rank: 663,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 3188,
              rank: 890,
            },
            likes: {
              title: "Likes",
              value: 32233,
              rank: 688,
            },
            videoLikes: {
              title: "Video Likes",
              value: 49,
              rank: 607,
            },
            videoViews: {
              title: "Video Views",
              value: 5173,
              rank: 602,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 14023863,
            },
          },
        },
      },
    },
  },
  {
    auctionID: 6882,
    symbolID: "AML_ET",
    symbolType: "Part of an album",
    title: `Sweet Child O' Mine`,
    genre: ["Rock", "Metal", "Hard Rock"],
    spotifyLink: "https://open.spotify.com/track/7o2CTH4ctstm8TNelqjb51",
    description: `"Sweet Child o' Mine" is a song by American rock band Guns N' Roses. It appears on their debut album, Appetite for Destruction. In the United States, the song was released in June 1988 as the album's third single, topping the Billboard Hot 100 chart and becoming the band's only US number-one single.`,
    startDate: "05/12/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 100,
    minAuctionTarget: 300000,
    minOrder: 50,
    currentPrice: "$14.35",
    priceIncrease: "$0.02",
    averageYield: "10%",
    LTMYield: "8.5%",
    lastPrice: "$14.35",
    weeklyVolume: "45",
    change: "3.01%",
    dalyGain: "$0.02",
    totalGain: "$7.8",
    royalties: "$12.39",
    aveCost: "$7.8",
    orderType: "Auction",
    bidPerUnit: "$19.21",
    bidUnits: "100",
    bidValue: "$1,921",
    askPerUnit: "$18.5",
    askUnits: "45",
    imgSrc: ["auctions/sweet-child2.png"],
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$198,000",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$150,000",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "2.34 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Part of an album",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "1",
      },
      {
        title: "Record lable",
        description: "Atlantic Records",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/1w7OgIMMRc4",
        thumbnail: "tracks/sweet-child.jpg",
      },
    ],
    tracks: [
      {
        id: "15359863",
        isrc: "USGF18714809",
        title: `Sweet Child O' Mine`,
        artist: `Guns N' Roses`,
        album: "The Box",
        releaseDate: "07/20/1987",
        spotifyLink: "https://open.spotify.com/track/7o2CTH4ctstm8TNelqjb51",
        imgSrc: "tracks/sweet-child.jpg",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.jpg",
            statistics: {
              score: {
                title: "Score",
                value: 2000,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 5003604,
              },
              likes: {
                title: "Likes",
                value: 516146337,
              },
              views: {
                title: "Views",
                value: 4114763138,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 161095443,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 257597084,
              },
              trackStations: {
                title: "Track Stations",
                value: 609002,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 83,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 69898713,
              },
              streams: {
                title: "Streams",
                value: 1634347508,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1182153699,
              },
              likes: {
                title: "Likes",
                value: 15105438,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3398236,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 9581043,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 563690,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 5731,
              },
              count: {
                title: "Listen Count",
                value: 631090,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 23878,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 748933,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://rapradar.com/2023/03/31/album-dj-drama-im-really-like-that/",
        title: "Album: DJ Drama ‘I’m Really Like That”",
        source: "Rap Radar",
        image_url:
          "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
        date: "2023-03-31T04:04:00.000Z",
      },
      {
        url: "https://www.billboard.com/lists/song-of-the-summer-2023-early-contenders/",
        title:
          "Way-Too-Early Song of the Summer 2023 Contenders: The Front-Runners, Outside Shots & Question Marks",
        source: "billboard",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
        date: "2023-03-30T19:55:01.000Z",
      },
      {
        url: "https://allhiphop.com/news/tyler-the-creator-explains-why-being-a-rapper-is-awesome/",
        title: "Tyler, The Creator Explains Why Being A Rapper Is “Awesome”",
        source: "AllHipHop",
        image_url:
          "https://video.primis.tech/uploads/video/users/logo/30526/logo_9860.png?cbuster=1616405498",
        date: "2023-03-30T12:33:30.000Z",
      },
      {
        url: "https://www.okayplayer.com/music/tyler-the-creator-sorry-not-sorry.html",
        title:
          "Watch Tyler, the Creator Channel All His Eras In the “Sorry Not Sorry” Music Video",
        source: "Okayplayer",
        image_url:
          "https://yt3.ggpht.com/ytc/AMLnZu9tabEaPKboW0n_5riHUHmVsHtycyBU6zvmlKnTpg=s88-c-k-c0x00ffffff-no-rj",
        date: "2023-03-29T16:54:24.000Z",
      },
      {
        url: "https://www.complex.com/music/best-new-music-this-week-march-6lack-bia-chloe/",
        title: "The Best New Music This Week: 6LACK, BIA, Chlöe, and More",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-24T19:02:52.000Z",
      },
      {
        url: "https://www.complex.com/music/internet-money-kodak-black-roddy-ricch-i-remember",
        title:
          'Internet Money Enlists Kodak Black and Roddy Ricch for New Single "I Remember"',
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-24T16:37:30.000Z",
      },
      {
        url: "https://www.clashmusic.com/news/internet-money-link-with-roddy-ricch-kodak-black-on-i-remember/",
        title:
          "Internet Money Link With Roddy Ricch, Kodak Black On ‘I Remember’",
        source: "Clash",
        image_url:
          "https://www.clashmusic.com/wp-content/themes/chop-child/images/clash-logo.png",
        date: "2023-03-24T11:30:50.000Z",
      },
      {
        url: "https://rapradar.com/2023/03/24/internet-money-ft-roddy-ricch-kodak-black-i-remember/",
        title: "Internet Money Ft. Roddy Ricch, Kodak Black “I Remember”",
        source: "Rap Radar",
        image_url:
          "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
        date: "2023-03-24T04:10:00.000Z",
      },
      {
        url: "https://streamlinemusicblog.com/2023/03/23/wpvr-ny-featured-music-schedule-03-24-23/",
        title:
          "WPVR NY Platinum Vibes Radio: FEATURED MUSIC AIRPLAY SCHEDULE – March 24, 2023",
        source: "StreamLINE Music Blog",
        image_url:
          "https://i1.wp.com/streamlinemusicblog.com/wp-content/uploads/2019/06/cropped-cropped-STREAMLINE-LOGO_500W.png?w=240&ssl=1",
        date: "2023-03-24T01:17:57.000Z",
      },
      {
        url: "https://streamlinemusicblog.com/2023/03/23/naqt-vane-first-digital-ep-chronic-music-video/",
        title:
          "Japan’s NAQT VANE release first digital EP, ‘NAQT’! Vocalist Harukaze and producer Hiroyuki SAWANO feature in ‘CHRONIC’ music video, directed by Classic 6!",
        source: "StreamLINE Music Blog",
        image_url:
          "https://i1.wp.com/streamlinemusicblog.com/wp-content/uploads/2019/06/cropped-cropped-STREAMLINE-LOGO_500W.png?w=240&ssl=1",
        date: "2023-03-23T20:21:00.000Z",
      },
    ],
    artist: {
      id: 839964,
      name: `Guns N' Roses`,
      biography: `Guns N' Roses are the bridge separating 1980s and 1990s hard rock, the band responsible for ushering in an era of grim, gritty rock & roll. Where such peers as Mötley Crüe reveled in the decadence of Sunset Strip sleaze, Guns N' Roses focused on the grimy underbelly of the urban jungle, with guitarists Slash and Izzy Stradlin cranking out mean riffs that matched the dark fantasies of Axl Rose , the vocalist who led GNR with a serpentine charm. `,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 9386911,
              rank: 207,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 1600000000,
              rank: 212,
            },
            popularity: {
              title: "Popularity",
              value: 79,
              rank: 251,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 205872707,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "40.81%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "21.93x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7152250,
              rank: 1058,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5400000,
              rank: 578,
              monthly_diff: {
                value: 0,
                percentage: 0,
              },
            },
            likes: {
              title: "Likes",
              value: 18500000,
              rank: 2173,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 10732294558,
              rank: 144,
            },
            postCount: {
              title: "Post Count",
              value: 13720262,
              rank: 74,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 6700000,
              rank: 616,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2940431924,
              rank: 617,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1085270,
              rank: 886,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 1200000000,
              rank: 869,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2683777,
              rank: 211,
            },
            streams: {
              title: "Streams",
              value: 1109384927,
              rank: 635,
            },
            artistStations: {
              title: "Artist Stations",
              value: 2511774,
              rank: 784,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 672490,
              rank: 933,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 48810362,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 1916,
              rank: 1465,
            },
            likes: {
              title: "Likes",
              value: 11014,
              rank: 1137,
            },
            plays: {
              title: "Plays",
              value: 1155570,
              rank: 1145,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1330,
              rank: 663,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 3188,
              rank: 890,
            },
            likes: {
              title: "Likes",
              value: 32233,
              rank: 688,
            },
            videoLikes: {
              title: "Video Likes",
              value: 49,
              rank: 607,
            },
            videoViews: {
              title: "Video Views",
              value: 5173,
              rank: 602,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 14023863,
            },
          },
        },
      },
    },
  },
  {
    auctionID: 6883,
    symbolID: "DML_RE",
    symbolType: "Part of an album",
    title: `Forest of Wishes`,
    genre: ["Electronic", "Ambient"],
    spotifyLink: "https://open.spotify.com/track/3fp2Bf3NbWgyyyreAHIwWL",
    startDate: "05/12/23 00:00:00",
    endDate: "06/12/23 00:00:00",
    units: 100,
    minAuctionTarget: 300000,
    minOrder: 50,
    currentPrice: "$14.35",
    priceIncrease: "$0.02",
    averageYield: "10%",
    LTMYield: "8.5%",
    lastPrice: "$14.35",
    weeklyVolume: "45",
    change: "3.01%",
    dalyGain: "$0.02",
    totalGain: "$7.8",
    royalties: "$12.39",
    aveCost: "$7.8",
    orderType: "Limit",
    bidPerUnit: "$8.01",
    bidUnits: "10",
    bidValue: "$1,921",
    askPerUnit: "$801",
    askUnits: "108",
    imgSrc: ["auctions/sweet-child.png"],
    financials: {
      LTMEarnings: {
        title: `Last 12 Months' Earnings`,
        description: "$235,000",
      },
      TYAEarnings: {
        title: "3 Year Average Earnings",
        description: "$201,000",
      },
      LTMYield: {
        title: "Last 12 Months Yield",
        description: "8.5%",
      },
      TYAYield: {
        title: "3-Year Average yield",
        description: "10%",
      },
      dollarAge: {
        title: "Dollar Age",
        description: "24.2 Y",
      },
      EarningsMultiple: {
        title: `Earning's Multiple (P/E)`,
        description: "11.8 X",
      },
      marketCap: {
        title: `Market Cap`,
        description: "$1,329,412",
      },
    },
    rights: [
      {
        title: "Musical Composition",
        description: "Public Performance, Mechanical",
      },
      {
        title: "Sound Recording",
        description: "Streaming",
      },
      {
        title: "Distributors",
        description: "ASCAP",
      },
      {
        title: "Copyrights",
        description: "Not included",
      },
      {
        title: "Symbol type",
        description: "Part of an album",
      },
      {
        title: "Listing Term",
        description: "Life",
      },
      {
        title: "Royalty Distribution Dates",
        description: "Mar 31, 1pm EST, Nov 30, 1pm EST",
      },
      {
        title: "Number of tracks",
        description: "1",
      },
      {
        title: "Record lable",
        description: "Atlantic Records",
      },
    ],
    videos: [
      {
        link: "https://www.youtube.com/embed/I-QDtFawtOo",
        thumbnail: "tracks/forest-of-wishes.jpg",
      },
    ],
    tracks: [
      {
        id: "14794314",
        isrc: "USA2P1425113",
        title: "Forest of Wishes",
        artist: "KLIMENT",
        album: "The Box",
        releaseDate: "07/20/2013",
        spotifyLink: "https://open.spotify.com/track/3fp2Bf3NbWgyyyreAHIwWL",
        imgSrc: "tracks/forest.jfif",
        socialMediaStatistics: {
          chartmetric: {
            socialMedia: "Chartmetric",
            icon: "social-media-logos/chartmetric.png",
            statistics: {
              score: {
                title: "Score",
                value: 2000,
              },
            },
          },
          tiktok: {
            socialMedia: "TikTok",
            icon: "social-media-logos/tiktok.png",
            statistics: {
              posts: {
                title: "Posts",
                value: 5003604,
              },
              likes: {
                title: "Likes",
                value: 516146337,
              },
              views: {
                title: "Views",
                value: 4114763138,
              },
            },
          },
          soundcloud: {
            socialMedia: "Soundcloud",
            icon: "social-media-logos/soundcloud.png",
            statistics: {
              totalPlays: {
                title: "Total Plays",
                value: 161095443,
              },
            },
          },
          pandora: {
            socialMedia: "Pandora",
            icon: "social-media-logos/pandora.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 257597084,
              },
              trackStations: {
                title: "Track Stations",
                value: 609002,
              },
            },
          },
          spotify: {
            socialMedia: "Spotify",
            icon: "social-media-logos/spotify.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 83,
              },
              playlistReach: {
                title: "Playlist Reach",
                value: 69898713,
              },
              streams: {
                title: "Streams",
                value: 1634347508,
              },
            },
          },
          youtube: {
            socialMedia: "Youtube",
            icon: "social-media-logos/youtube.png",
            statistics: {
              views: {
                title: "Views",
                value: 1182153699,
              },
              likes: {
                title: "Likes",
                value: 15105438,
              },
            },
          },
          genius: {
            socialMedia: "Genius",
            icon: "social-media-logos/genius.png",
            statistics: {
              views: {
                title: "Views",
                value: 3398236,
              },
            },
          },
          shazam: {
            socialMedia: "Shazam",
            icon: "social-media-logos/shazam.png",
            statistics: {
              count: {
                title: "Count",
                value: 9581043,
              },
            },
          },
          deezer: {
            socialMedia: "Deezer",
            icon: "social-media-logos/deezer.png",
            statistics: {
              playlistReach: {
                title: "Playlist Reach",
                value: 563690,
              },
            },
          },
          line: {
            socialMedia: "Line",
            icon: "social-media-logos/line.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 5731,
              },
              count: {
                title: "Listen Count",
                value: 631090,
              },
            },
          },
          melon: {
            socialMedia: "Melon",
            icon: "social-media-logos/melon.png",
            statistics: {
              likes: {
                title: "Likes",
                value: 23878,
              },
            },
          },
          airplay: {
            socialMedia: "Airplay",
            icon: "social-media-logos/airplay.png",
            statistics: {
              streams: {
                title: "Streams",
                value: 748933,
              },
            },
          },
          tidal: {
            socialMedia: "Tidal",
            icon: "social-media-logos/tidal.png",
            statistics: {
              popularity: {
                title: "Popularity",
                value: 87,
              },
            },
          },
        },
      },
    ],
    mentions: [
      {
        url: "https://rapradar.com/2023/03/31/album-dj-drama-im-really-like-that/",
        title: "Album: DJ Drama ‘I’m Really Like That”",
        source: "Rap Radar",
        image_url:
          "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
        date: "2023-03-31T04:04:00.000Z",
      },
      {
        url: "https://www.billboard.com/lists/song-of-the-summer-2023-early-contenders/",
        title:
          "Way-Too-Early Song of the Summer 2023 Contenders: The Front-Runners, Outside Shots & Question Marks",
        source: "billboard",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Billboard_logo.svg/280px-Billboard_logo.svg.png",
        date: "2023-03-30T19:55:01.000Z",
      },
      {
        url: "https://allhiphop.com/news/tyler-the-creator-explains-why-being-a-rapper-is-awesome/",
        title: "Tyler, The Creator Explains Why Being A Rapper Is “Awesome”",
        source: "AllHipHop",
        image_url:
          "https://video.primis.tech/uploads/video/users/logo/30526/logo_9860.png?cbuster=1616405498",
        date: "2023-03-30T12:33:30.000Z",
      },
      {
        url: "https://www.okayplayer.com/music/tyler-the-creator-sorry-not-sorry.html",
        title:
          "Watch Tyler, the Creator Channel All His Eras In the “Sorry Not Sorry” Music Video",
        source: "Okayplayer",
        image_url:
          "https://yt3.ggpht.com/ytc/AMLnZu9tabEaPKboW0n_5riHUHmVsHtycyBU6zvmlKnTpg=s88-c-k-c0x00ffffff-no-rj",
        date: "2023-03-29T16:54:24.000Z",
      },
      {
        url: "https://www.complex.com/music/best-new-music-this-week-march-6lack-bia-chloe/",
        title: "The Best New Music This Week: 6LACK, BIA, Chlöe, and More",
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-24T19:02:52.000Z",
      },
      {
        url: "https://www.complex.com/music/internet-money-kodak-black-roddy-ricch-i-remember",
        title:
          'Internet Money Enlists Kodak Black and Roddy Ricch for New Single "I Remember"',
        source: "Complex",
        image_url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Complex_networks.jpg/220px-Complex_networks.jpg",
        date: "2023-03-24T16:37:30.000Z",
      },
      {
        url: "https://www.clashmusic.com/news/internet-money-link-with-roddy-ricch-kodak-black-on-i-remember/",
        title:
          "Internet Money Link With Roddy Ricch, Kodak Black On ‘I Remember’",
        source: "Clash",
        image_url:
          "https://www.clashmusic.com/wp-content/themes/chop-child/images/clash-logo.png",
        date: "2023-03-24T11:30:50.000Z",
      },
      {
        url: "https://rapradar.com/2023/03/24/internet-money-ft-roddy-ricch-kodak-black-i-remember/",
        title: "Internet Money Ft. Roddy Ricch, Kodak Black “I Remember”",
        source: "Rap Radar",
        image_url:
          "https://s11279.pcdn.co/wp-content/themes/rapradar-desktop/images/logo_rapradar_footer.png",
        date: "2023-03-24T04:10:00.000Z",
      },
      {
        url: "https://streamlinemusicblog.com/2023/03/23/wpvr-ny-featured-music-schedule-03-24-23/",
        title:
          "WPVR NY Platinum Vibes Radio: FEATURED MUSIC AIRPLAY SCHEDULE – March 24, 2023",
        source: "StreamLINE Music Blog",
        image_url:
          "https://i1.wp.com/streamlinemusicblog.com/wp-content/uploads/2019/06/cropped-cropped-STREAMLINE-LOGO_500W.png?w=240&ssl=1",
        date: "2023-03-24T01:17:57.000Z",
      },
      {
        url: "https://streamlinemusicblog.com/2023/03/23/naqt-vane-first-digital-ep-chronic-music-video/",
        title:
          "Japan’s NAQT VANE release first digital EP, ‘NAQT’! Vocalist Harukaze and producer Hiroyuki SAWANO feature in ‘CHRONIC’ music video, directed by Classic 6!",
        source: "StreamLINE Music Blog",
        image_url:
          "https://i1.wp.com/streamlinemusicblog.com/wp-content/uploads/2019/06/cropped-cropped-STREAMLINE-LOGO_500W.png?w=240&ssl=1",
        date: "2023-03-23T20:21:00.000Z",
      },
      {
        url: "https://allhiphop.com/news/watch-the-trailer-for-hulus-rapcaviar-presents-featuring-tyler-the-creator-city-girls-more/",
        title:
          "Watch The Trailer For Hulu’s ‘RapCaviar Presents’ Featuring Tyler The Creator, City Girls & More",
        source: "AllHipHop",
        image_url:
          "https://video.primis.tech/uploads/video/users/logo/30526/logo_9860.png?cbuster=1616405498",
        date: "2023-03-23T13:52:56.000Z",
      },
    ],
    artist: {
      id: 839964,
      name: `Kliment`,
      biography: `Kliment (Cyrillic: Климент) is a male given name, a Slavic form of the Late Latin name Clement. A diminutive form is Klim.`,
      career: {
        stage: "Superstar",
        socialMediaImpact: "Good",
        growth: "Steady",
      },
      socialMediaStatistics: {
        spotify: {
          socialMedia: "Spotify",
          icon: "social-media-logos/spotify.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 9386911,
              rank: 207,
              monthly_diff: {
                value: 107252,
                percentage: 1.1558,
              },
            },
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 1600000000,
              rank: 212,
            },
            popularity: {
              title: "Popularity",
              value: 79,
              rank: 251,
            },
            playlistReach: {
              title: "Playlist Reach",
              value: 205872707,
            },
            fanConversionRate: {
              title: "Fan Conversion Rate",
              value: "40.81%",
            },
            reachFollowersRatio: {
              title: "Reach / Followers Ratio",
              value: "21.93x",
            },
          },
        },
        instagram: {
          socialMedia: "Instagram",
          icon: "social-media-logos/instagram.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 7152250,
              rank: 1058,
              monthly_diff: {
                value: 25955,
                percentage: 0.3642,
              },
            },
          },
        },
        tiktok: {
          socialMedia: "TikTok",
          icon: "social-media-logos/tiktok.png",
          statistics: {
            followers: {
              title: "Followers",
              value: 5400000,
              rank: 578,
              monthly_diff: {
                value: 0,
                percentage: 0,
              },
            },
            likes: {
              title: "Likes",
              value: 18500000,
              rank: 2173,
              monthly_diff: {
                value: 28341,
                percentage: 1.9495,
              },
            },
            topVideoViews: {
              title: "Top Video Views",
              value: 10732294558,
              rank: 144,
            },
            postCount: {
              title: "Post Count",
              value: 13720262,
              rank: 74,
            },
          },
        },
        youtube: {
          socialMedia: "YouTube",
          icon: "social-media-logos/youtube.png",
          statistics: {
            channelSubscribers: {
              title: "Channel Subscribers",
              value: 6700000,
              rank: 616,
              monthly_diff: {
                value: 30000,
                percentage: 0.4498,
              },
            },
            channelViews: {
              title: "Channel Views",
              value: 2940431924,
              rank: 617,
            },
            dailyVideoViews: {
              title: "Daily Video Views",
              value: 1085270,
              rank: 886,
            },
            monthlyVideoViews: {
              title: "Monthly Video Views",
              value: 1200000000,
              rank: 869,
            },
          },
        },
        pandora: {
          socialMedia: "Pandora",
          icon: "social-media-logos/pandora.png",
          statistics: {
            monthlyListeners: {
              title: "Monthly Listeners",
              value: 2683777,
              rank: 211,
            },
            streams: {
              title: "Streams",
              value: 1109384927,
              rank: 635,
            },
            artistStations: {
              title: "Artist Stations",
              value: 2511774,
              rank: 784,
            },
          },
        },
        deezer: {
          socialMedia: "Deezer",
          icon: "social-media-logos/deezer.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 672490,
              rank: 933,
            },
          },
        },
        shazam: {
          socialMedia: "Shazam",
          icon: "social-media-logos/shazam.png",
          statistics: {
            totalCount: {
              title: "Total Count",
              value: 48810362,
            },
          },
        },
        line: {
          socialMedia: "Line",
          icon: "social-media-logos/line.png",
          statistics: {
            artistLikes: {
              title: "Artist Likes",
              value: 1916,
              rank: 1465,
            },
            likes: {
              title: "Likes",
              value: 11014,
              rank: 1137,
            },
            plays: {
              title: "Plays",
              value: 1155570,
              rank: 1145,
            },
            videoPlays: {
              title: "Music Video Plays",
              value: 1330,
              rank: 663,
            },
          },
        },
        melon: {
          socialMedia: "Melon",
          icon: "social-media-logos/melon.png",
          statistics: {
            fans: {
              title: "Fans",
              value: 3188,
              rank: 890,
            },
            likes: {
              title: "Likes",
              value: 32233,
              rank: 688,
            },
            videoLikes: {
              title: "Video Likes",
              value: 49,
              rank: 607,
            },
            videoViews: {
              title: "Video Views",
              value: 5173,
              rank: 602,
            },
          },
        },
        genius: {
          socialMedia: "Genius",
          icon: "social-media-logos/genius.png",
          statistics: {
            views: {
              title: "Page Views",
              value: 14023863,
            },
          },
        },
      },
    },
  },
];

export default AUCTIONS_DATA;
